import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-loading-skeleton/dist/skeleton.css';
import { AppConfiguration } from 'config';
import {
  Alert,
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from 'reactstrap';
import useFeatureFlags from "hooks/useFeatureFlags"
import useFeatureFlagsForAccounts from "hooks/useFeatureFlagsForAccounts"
import DateRangePicker, { DATE_RANGE_OPTIONS, DATE_RANGE_OPTIONS_DISPLAY, createLabelWithDateRange, createOption } from 'components/Common/DateRangePicker';
import { Link, useHistory } from 'react-router-dom';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit';
import {
  duplicateCampaign, getCampaigns, modifyCampaign, resetLastCompletedAction, deleteMultipleCampaign,
} from 'store/actions';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import { 
  getMetricNamesForPixelStats, 
  addNumbersSafely, 
  manageBudgetsAdminPermission, 
  getCampaignStyles, 
  createPixelColumns, 
  getMonthlyBudgetStringForCell,
  undefinedNullCellFormatter,
  getDailyBudgetStringForCell,
  CAMPAIGN_FILTERS,
  getSelectBox,
  sortDailyLimit,
  sortMonthlyLimit,
  optionGroupStatus,
  optionBulkEdit
} from 'helpers/sf_campaign_helper';
import { KEY_NAMES } from "helpers/sf_constants";
import { formatDatePST } from "helpers/time_utils";
import { doesAccountHaveDailyBudgetOptions, getBudgetOptionsForAccount, getCampaignBudgetUIState } from 'helpers/sf_campaign_budgets_helper';
import {
  ADMIN_ONLY_TAB,
  CAMPAIGN_TABLE_COLMN_NAME, DailyBudgetType, INFINITY, LEAD_TYPES, MAX_BUDGETS, MODIFICATION_TYPE, MonthlyBudgetType, NAME_OF_LEAD_TYPES, NAME_OF_PRODUCT_TYPES, OPTION_ALL, optionGroupProduct, PAGES_FOR_DRAGGABLE_CUSTOMIZE_COLUMN, PIXEL_COLUMN_TABLE_FIELDS, PRODUCT_TYPE_IDS, REQUIRED_FEATURE_FLAGS, RTB_ACCOUNT_ID, sortColumnsByOrder, TOOLTIPS,
} from 'helpers/sf_constants';
import { DAY_ARRARY } from 'helpers/sf_campaign_schedule_helper';
import {
  capitalizeWord, changeOptionValueToDateObject, dollarFormatWithTwoDecimalPlaces, getSafePercentage, getIANATimezoneStringForAbbreviation, getPrimaryButtonClass, handleSessionTimeOut, IsAccountRetailAndProductTypeIsLeadsOrCalls, IsMonthlyBudgetFeatureEnabled, maxBudgetAndUnitsLimit, nullHandlerCustomizeColumns, percentFormatWithTwoDecimalPlaces, SfCommaStringFormatter, Sfdelimitter, SfDollarStringFormatter, SfPercentStringFormatter, sortStringAsFloat, getSafeDivision, createDefaultColumnSortedObject, forColumnHeaderWrapper, calculateColumnOrders,
  getDropdownButtonLabelForBrands,
  getUpdatedOptionsFromEvent,
  filteredConversionPixels,
  handleColumnsForCsvExport,
} from 'helpers/sf_utils';
import * as Formatters from 'pages/Admin/Users/UserComponents/UserList/Formatters';
import { useDispatch, useSelector } from 'react-redux';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import BootstrapTable from 'react-bootstrap-table-next';
import Breadcrumbs from 'components/Common/Breadcrumb';
import MetaTags from 'react-meta-tags';
import Select from 'react-select';
import ToastAlert, { ToastAlertIconType } from 'components/Common/ToastAlert/ToastAlert';
import NumberFormat from 'react-number-format';
import { MODIFY_CAMPAIGN_SUCCESS } from 'store/campaign/actionTypes';
import ModifyLoadingIcon from 'components/Common/Loadings/ModifyLoadingIcon';
import SfLoadingSkeleton from 'components/Common/Loadings/SfLoadingSkeleton';
import DeleteCampaignModal from './DeleteCampaignModal';
import _ from 'lodash';
import { UI_PERMISSION_KEY } from 'pages/Roles/newFeaturesAndPermissionsData';
import { getCampaignStickyColumns, updateCampaignStickyColumns } from 'store/user_column_preference/campaign-sticky-columns/actions';
import CustomizeColumnsModal from '../CommonComponents/CustomizeColumnsModals/CustomizeColumnsModal';
import { getCallConversionPixelsAggCampaigns, getClickConversionPixelsAggCampaigns, getConversionPixelsAggCampaignsV3, getLeadConversionPixelsAggCampaigns, modifyClickConversionPixels } from 'store/conversions/actions';
import { getMargin, getProfit } from 'helpers/sf_adgroup_helper';
import useCampaignsWithStats from 'hooks/useCampaignsWithStats';
import { bsh_getFilters, bsh_isAdminUserDetailsPresent, bsh_setFilters, STORAGE_KEY } from 'helpers/sf_browser_storage_helper';
import Skeleton from 'react-loading-skeleton';
import ReactDOM from 'react-dom';
import useClientPermissionsAccess from 'hooks/useClientPermissionsAccess';
import useCanManageCampaign from 'hooks/useCanManageCampaign';
import { timeFormatter } from 'helpers/sf_dashboard_helper';
import useUrlFilter from 'hooks/useUrlFilter';
import usePlatformSettings from 'hooks/usePlatformSettings';
import { createCampaignNotes, getCampaignNotes } from 'store/notes/campaign_notes/actions';
import CampaignNoteModal from 'components/Common/Notes/CampaignNoteModal';
import StickyBootstrapTableWrapper from 'components/Common/StickyBootstrapTableWrapper';
import { ORDER_BY } from 'common/sf_strings';
import useAdminPermissionCheck from 'hooks/useAdminPermissionCheck';
import { getQuoteFunnels } from 'store/quote_funnels/actions';
import { isGoalBrand } from 'config';
import { getAggQuoteFunnelsStatsForCampaigns } from 'store/quote-funnels-stats/actions';
import { getAggMarketplaceStatsForCampaigns } from 'store/marketplace-stats/actions';
import AdminOnlyIcon from 'components/Common/AdminOnlyIcon';
import useDistinctAccountProductTypes from 'hooks/useDistinctAccountProductTypes';
import { getCustomizeOrder, updateCustomizeOrder } from 'store/customize-order/actions';
import { customSortCaret } from 'helpers/bootstrap_table_helper';
import useTextSelection from 'hooks/useTextSelection';
import { isIABrand } from 'config';
import { isSfproBrand } from 'config';
import { isInsuranceioBrand } from 'config';
import useFilteredLeadTypes from 'hooks/useFilteredLeadTypes';
import ReactMultiselectCheckboxes from 'react-multiselect-checkboxes/lib/ReactMultiselectCheckboxes';
import useNewBrandUI from 'hooks/useNewBrandUI';
import useSingleActionDispatcher from 'hooks/useSingleActionDispatcher';
import useClientV3Stats from 'hooks/useClientV3Stats';
import { getCampaignProductLabel } from 'helpers/sf_lead_marketplace_helper';
import { getCampaignPixelMetricValues } from 'helpers/campaign_pixel_metrics';

// programmatically setting the productTypeFilter and lead type filter for react bootstrap table 2
// https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html?selectedKind=Column+Filter&selectedStory=Programmatically+Text+Filter&full=0&addons=1&stories=1&panelRight=0&addonPanel=storybook%2Factions%2Factions-panel
let productTypeFilter = null;
let leadTypeFilter = null;
let statusFilter = null;
let nameFilter = null;

function QfCampaignsPage(_props) {

  const {
    loading, error, lastCompletedAction, modify_campaign_loading,
    click_conversion_pixels_aggregated_loading, user_column_preference_campaign_loading,
    lead_conversion_pixels_agg_loading, call_conversion_pixels_agg_loading,
    last_fetch_all_campaigns_time_frame_key, current_account,
    current_role_permissions_state, user_column_preference_campaign,
    click_conversion_pixels, click_conversion_pixels_agg_campaigns,
    lead_conversion_pixels_agg_campaigns, call_conversion_pixels_agg_campaigns,
    last_fetch_all_cmps_stats_time_key, loading_all_cmps_stats,
    loading_all_cmps_call_stats, loading_all_cmps_lead_stats, campaign_notes,
    campaign_notes_loading, qf_agg_campaigns_data, qf_agg_campaigns_loading,
    qf_agg_campaigns_error, marketplace_agg_campaigns_data, marketplace_agg_campaigns_loading,
    campaigns_customize_order_for_campaigns, brands,
    click_campaign_stats_loading, last_fetch_all_cmps_stats_custom_date_range,
    last_fetch_all_campaigns_custom_date_range, last_failed_all_campaigns_fetch,
  } = useSelector((state) => ({
    error: state.Campaign.error,
    loading: state.Campaign.loading,
    modify_campaign_loading: state.Campaign.modify_campaign_loading,
    click_conversion_pixels_aggregated_loading: state.Conversions.loading,
    lead_conversion_pixels_agg_loading: state.Conversions.lead_conversion_pixels_agg_loading,
    call_conversion_pixels_agg_loading: state.Conversions.call_conversion_pixels_agg_loading,
    lastCompletedAction: state.Campaign.lastCompletedAction,
    last_fetch_all_campaigns_time_frame_key: state.Campaign.last_fetch_all_campaigns_time_frame_key,
    last_fetch_all_campaigns_custom_date_range: state.Campaign.last_fetch_all_campaigns_custom_date_range,
    last_failed_all_campaigns_fetch: state.Campaign.last_failed_all_campaigns_fetch,
    current_account: state.accounts.current_account,
    current_role_permissions_state: state.Role.current_role_permissions_state,
    user_column_preference_campaign: state.UserCampaignColumnPreference.user_column_preference_campaign,
    user_column_preference_campaign_loading: state.UserCampaignColumnPreference.loading,
    click_conversion_pixels: state.Conversions.click_conversion_pixels,
    click_conversion_pixels_agg_campaigns: state.Conversions.click_conversion_pixels_agg_campaigns,
    lead_conversion_pixels_agg_campaigns: state.Conversions.lead_conversion_pixels_agg_campaigns,
    call_conversion_pixels_agg_campaigns: state.Conversions.call_conversion_pixels_agg_campaigns,
    last_fetch_all_cmps_stats_time_key: state.Campaign.last_fetch_all_cmps_stats_time_key,
    last_fetch_all_cmps_stats_custom_date_range: state.Campaign.last_fetch_all_cmps_stats_custom_date_range,
    loading_all_cmps_stats: state.Campaign.loading_all_cmps_stats,
    loading_all_cmps_call_stats: state.Campaign.loading_all_cmps_call_stats,
    click_campaign_stats_loading: state.Campaign.click_campaign_stats_loading,
    loading_all_cmps_lead_stats: state.Campaign.loading_all_cmps_lead_stats,
    campaign_notes: state.campaignNotesReducer.campaign_notes,
    campaign_notes_loading: state.campaignNotesReducer.campaign_notes_loading,
    qf_agg_campaigns_data: state.quoteFunnelsStatsReducer.qf_agg_campaigns_data,
    qf_agg_campaigns_loading: state.quoteFunnelsStatsReducer.qf_agg_campaigns_loading,
    qf_agg_campaigns_error: state.quoteFunnelsStatsReducer.qf_agg_campaigns_error,
    marketplace_agg_campaigns_data: state.marketplaceStatsReducer.marketplace_agg_campaigns_data,
    marketplace_agg_campaigns_loading: state.marketplaceStatsReducer.marketplace_agg_campaigns_loading,
    campaigns_customize_order_for_campaigns: state.CustomizeOrder.orders,
    brands: state.Brands.brands,
  }));
  const IS_RTB_ACCOUNT = isInsuranceioBrand && current_account?.id == RTB_ACCOUNT_ID
  const [isFeatureFlagActive, areFeatureFlagsLoaded] = useFeatureFlags();
  const [isFeatureFlagActiveForAccount] = useFeatureFlagsForAccounts();

  const show_rtb_brand_ui_changes = useNewBrandUI()

  const campaigns_customize_order = useMemo(() => {
    if (campaigns_customize_order_for_campaigns?.campaigns) {
      return JSON.parse(campaigns_customize_order_for_campaigns.campaigns)
    }
    return null;
  }, [campaigns_customize_order_for_campaigns])

  const dropdownMenuRefCampaignName = useRef(null);
  const dropdownMenuRefCampaignDayLimits = useRef(null);
  const dropdownMenuRefCampaignMonthLimits = useRef(null);
  const { isMetricsEnabled, isClicksProductEnabled, isProfilesEnabled, isSourceSettingsEnabled } = usePlatformSettings();
  const { isTextSelected, handleTextSelection, setIsTextSelected } = useTextSelection();
  const dispatch = useDispatch();
  const [campaignsList, setCampaignsList] = useState([]);
  const [isEditingName, setIsEditingName] = useState({});
  const [isEditingDailyBudget, setIsEditingDailyBudget] = useState({});
  const [isEditingMonthlyBudget, setIsEditingMonthlyBudget] = useState({});
  const [editIconRow, setEditIconRow] = useState(); // State variable to show/hide
  const [bulkEdit, setbulkEdit] = useState();
  const [campaignNoteModal, setCampaignNoteModal] = useState({ action: false });
  const [sortOrderForName, setSortOrderForName] = useState({});
  const { distinctProductTypes, hasClicks, hasCalls, hasLeads, hasSyndiClicks, hasQuoteFunnels } = useDistinctAccountProductTypes();
  const [customizeColumnsOrder, setCustomizeColumnsOrder] = useState({})
  const { ExportCSVButton } = CSVExport;
  // state of select groups
  const [nameInput, setNameInput] = useState('');
  const [optionsCampaignProducts, setOptionsCampaignProducts] = useState([]);
  const [brandsOptions, setBrandsOptions] = useState([])
  const [selectedBrands, setSelectedBrands] = useState(bsh_getFilters(STORAGE_KEY.FILTERS.CAMPAIGN, CAMPAIGN_FILTERS.BRANDS) || [])
  const [selectedProductGroup, setSelectedProductGroup] = useState(bsh_getFilters(STORAGE_KEY.FILTERS.CAMPAIGN, CAMPAIGN_FILTERS.PRODUCT) || optionsCampaignProducts[0] || optionGroupProduct[0].options[0]);
  const filteredLeadTypes = useFilteredLeadTypes(LEAD_TYPES, selectedProductGroup?.value, false);
  const LEAD_TYPE_OPTIONS = [
    {
      label: 'Insurance Type',
      options: [{ label: 'All', value: '' }, ...filteredLeadTypes.map(element => ({ label: capitalizeWord(element.name), value: element.name }))],
    },
  ]
  const [optionLeadTypesState, setOptionLeadTypesState] = useState(LEAD_TYPE_OPTIONS)
  const [selectedLeadGroup, setSelectedLeadGroup] = useState(bsh_getFilters(STORAGE_KEY.FILTERS.CAMPAIGN, CAMPAIGN_FILTERS.LEAD_TYPE) || optionLeadTypesState[0].options[0]);
  const [selectedStatusGroup, setSelectedStatusGroup] = useState(bsh_getFilters(STORAGE_KEY.FILTERS.CAMPAIGN, CAMPAIGN_FILTERS.STATUS) || optionGroupStatus[0].options[0]);

  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedName, setSelectedName] = useState('');
  const [loadingCell, setLoadingCell] = useState({ row: null, col: null });


  const [visibleAlert, setVisibleAlert] = useState(false);

  const roas_column_show_ff = useMemo(() => isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_ROAS), [isFeatureFlagActive]);
  const new_campaign_page_feature_flag_active = useMemo(() => isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_NEW_CAMPAIGNS_PAGE_UI), [isFeatureFlagActive])
  const goal_marketplace_flag_active = useMemo(() => isFeatureFlagActiveForAccount(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_GOAL_MARKETPLACE, current_account), [isFeatureFlagActiveForAccount, current_account])
  const marketplace_leads_loading = goal_marketplace_flag_active && marketplace_agg_campaigns_loading;
  const leads_stats_loading = loading_all_cmps_lead_stats || marketplace_leads_loading;
  const { use_v3_api_for_campaign_stats, use_v3_api_for_campaign_conversion_stats } = useClientV3Stats();
  const show_pixel_stats_for_leads_and_calls = useMemo(() => isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FlAG_SHOW_PIXEL_STATS_FOR_LEADS_AND_CALLS), [isFeatureFlagActive])
  const ff_user_new_win_rate = useMemo(() => isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_USE_NEW_WIN_RATE_FORMULA), [isFeatureFlagActive])

  const enable_sticky_columns = useMemo(() => isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEAURE_FLAG_ENABLE_STICKY_COLUMNS), [isFeatureFlagActive])

  const sourceSettingEnabledFromAccountSetting = (isGoalBrand || isIABrand || isSfproBrand) && current_account?.source_settings_enabled

  const handleVisible = () => {
    setTimeout(() => {
      setVisibleAlert(false)
    }, 2000);
  }

  useEffect(() => {
    return () => {
      handleVisible();
    }
  }, [visibleAlert]);
  useEffect(() => {
    isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_CAMPAIGNS_PAGE) &&
      dispatch(getCustomizeOrder({ page_name: PAGES_FOR_DRAGGABLE_CUSTOMIZE_COLUMN.CAMPAIGNS }))
  }, [])

  useSingleActionDispatcher(getCampaignStickyColumns());

  useEffect(() => {
    isGoalBrand && dispatch(getQuoteFunnels())
  }, []);
  
  const [dynamicColumns, setDynamicColumns] = useState([]);
  const [campaigns] = useCampaignsWithStats();
  const [adminPermissionPresent] = useAdminPermissionCheck();

  const history = useHistory();

  const filteredCampaignsList = useMemo(() => {
    let filteredCampaigns = _.cloneDeep(campaignsList);

    if (filteredCampaigns?.length === 0 || selectedBrands?.length === 0) {
      return [];
    }

    if (selectedProductGroup.value) {
      filteredCampaigns = filteredCampaigns.filter((campaign) => campaign?.product_type?.name === selectedProductGroup.value);
    }

    if (selectedStatusGroup.value) {
      filteredCampaigns = filteredCampaigns.filter((campaign) => (campaign?.active ? 'Active' : 'Paused') === selectedStatusGroup?.value);
    }

    if (selectedLeadGroup?.value) {
      filteredCampaigns = filteredCampaigns.filter((campaign) => campaign?.lead_type?.name === selectedLeadGroup.value);
    }

    if (selectedName) {
      filteredCampaigns = filteredCampaigns.filter((campaign) => campaign?.name?.toLowerCase().includes(selectedName.toLowerCase()));
    }

    if (selectedBrands?.length && show_rtb_brand_ui_changes) {
      filteredCampaigns = filteredCampaigns.filter((campaign) =>
        selectedBrands.some((el) => el?.value === campaign?.brand?.name)
      );
    }

    return filteredCampaigns;
  }, [campaignsList, selectedStatusGroup, selectedProductGroup, selectedLeadGroup, selectedName, selectedBrands]);

  const activeConversionPixels = useMemo(() => {
    return filteredConversionPixels(click_conversion_pixels, show_rtb_brand_ui_changes, campaigns[0]?.brand_id)
  }, [click_conversion_pixels, show_rtb_brand_ui_changes, campaigns])


  const { combinedCampaignsStats, footerStats } = useMemo(() => {
    const total_stats = {
      click_analytic_impressions: [], // Impressions
      impressions: [], // Impressions
      searches: [], // Bids
      total_units: [], // Units
      click_analytic_searches: [], // Bids
      click_analytic_clicks: [], // Units
      click_analytic_total_payout: [], // Total cost
      total_cost: [], // Total cost
      click_analytic_cpc: [], // Cost Per Unit
      avg_unit_cost: [], // Cpx
      profit: [], // Profit
      contribution_margin: [], // CM
      revenue: [], // Revenue
      campaign_pace: [], // Pace
      queries: [], // Opportunities,
      win_rate: [],
      click_analytic_total_inventory: [], // inventory
      click_analytic_total_opportunities: [], // Opportunities
      click_analytic_total_searches: [], // Bids
      click_analytic_total_clicks: [],  // Transfers
      click_analytic_prefill_success_rate: [],
      leads_generated_count: [], // Qualified Leads
      calls_generated_count: [], // Qualified Calls
      click_analytic_avg_cpc: [],
      click_analytic_total_cost: [],
      call_analytic_total_inventory: [], // inventory
      call_analytic_total_opportunities: [], // Opportunities
      call_analytic_total_searches: [], // Bids
      call_analytic_total_calls: [],  // Transfers
      call_analytic_total_accepted: [], // Qualified Calls
      call_analytic_total_cost: [],
      call_analytic_avg_call_duration: [],
      lead_analytic_total_inventory: [], // inventory
      lead_analytic_total_opportunities: [], // Opportunities
      lead_analytic_total_searches: [], // Bids
      lead_analytic_total_won: [],  // Transfers
      lead_analytic_total_leads: [], // Qualified Calls
      lead_analytic_total_cost: [],
      lead_analytic_avg_call_duration: [],
      total_conversions: [],
      total_revenue: [],
    }

    // objects for calculation
    const calculation_stat_objecs = {
      call_analytic_avg_cpc: 'call_analytic_avg_cpc',
      lead_analytic_avg_cpl: 'lead_analytic_avg_cpl',
      call_analytic_target_rate: 'call_analytic_target_rate',
      call_analytic_bid_rate: 'call_analytic_bid_rate',
      call_analytic_success_rate: 'call_analytic_success_rate',
      lead_analytic_target_rate: 'lead_analytic_target_rate',
      lead_analytic_bid_rate: 'lead_analytic_bid_rate',
      lead_analytic_success_rate: 'lead_analytic_success_rate',
      click_analytic_target_rate: 'click_analytic_target_rate',
      click_analytic_bid_rate: 'click_analytic_bid_rate',
      click_analytic_success_rate: 'click_analytic_success_rate',
      bid: "bid",
      avg_bid: "avg_bid", // Avg bid
      win_rate: 'win_rate', // Win rate
      click_analytic_avg_bid: 'click_analytic_avg_bid',
      call_analytic_avg_bid: "call_analytic_avg_bid",
      lead_analytic_avg_bid: "lead_analytic_avg_bid",
      custom_click_analytic_bid: 'custom_click_analytic_bid',
      custom_call_analytic_bid: "custom_call_analytic_bid",
      custom_lead_analytic_bid: "custom_lead_analytic_bid",
      click_analytic_prefill_success_rate: 'click_analytic_prefill_success_rate',
      total_conversions: 'total_conversions',
      total_revenue: 'total_revenue',
    }

    // extra stats for click_analytic_avg_bid and click_analytic_avg_pos
    const extra_stats = {
      [calculation_stat_objecs.bid]: [],
      [calculation_stat_objecs.custom_click_analytic_bid]: [],
      [calculation_stat_objecs.custom_call_analytic_bid]: [],
      [calculation_stat_objecs.custom_lead_analytic_bid]: []
    }

    const total_stat_objects = Object.keys(total_stats)
      .map(stat => ({ [stat]: stat }))
      .reduce((acc, curr) => { return { ...acc, ...curr } }, {});
    const totalPrefillSuccessValues = filteredCampaignsList.map(campaign => { return campaign.click_analytic_prefill_success_rate * (new_campaign_page_feature_flag_active ? campaign.click_analytic_total_clicks : campaign.click_analytic_clicks) })
      .reduce((acc, curr) => acc + (curr || 0), 0);

    const enable_pixel_stats = [...Object.values(total_stat_objects)];

    activeConversionPixels.forEach((pixel) => {
      const pixel_stat_name = `${pixel.id}:${pixel.name}`;
      const pixel_stat_name_rev = `${pixel.id}:${pixel.name} Rev`;
      const pixel_stat_name_cvr = `${pixel.id}:${pixel.name} CVR`;
      const pixel_stat_name_cpa = `${pixel.id}:${pixel.name} CPA`;
      const pixel_stat_name_roas = `${pixel.id}:${pixel.name} ROAS`;

      enable_pixel_stats.push(pixel_stat_name);
      enable_pixel_stats.push(pixel_stat_name_rev);
      enable_pixel_stats.push(pixel_stat_name_cvr);
      enable_pixel_stats.push(pixel_stat_name_cpa);
      enable_pixel_stats.push(pixel_stat_name_roas);

      total_stats[pixel_stat_name] = [];
      total_stats[pixel_stat_name_rev] = [];
      total_stats[pixel_stat_name_cvr] = [];
      total_stats[pixel_stat_name_cpa] = [];
      total_stats[pixel_stat_name_roas] = [];
    });

    const getWinRate = (row) => {
      switch (row?.product_type.id) {
        case PRODUCT_TYPE_IDS.CLICKS:
        case PRODUCT_TYPE_IDS.SYNDI_CLICKS:
          return getSafeDivision(ff_user_new_win_rate ? row?.click_analytic_clicks : row?.click_analytic_impressions, row?.click_analytic_searches)
        case PRODUCT_TYPE_IDS.LEADS:
          return getSafeDivision(row?.lead_analytic_total_won, row?.searches);
        case PRODUCT_TYPE_IDS.CALLS:
          return getSafeDivision(row?.call_analytic_total_calls, row?.searches);
        default:
          return 0;
      }
    }

    const getWinRateV2 = (row) => {
      switch (row?.product_type.id) {
        case PRODUCT_TYPE_IDS.CLICKS:
        case PRODUCT_TYPE_IDS.QUOTE_FUNNELS:
          return getSafeDivision(ff_user_new_win_rate ? row?.click_analytic_total_clicks : row?.click_analytic_impressions, row?.click_analytic_total_searches);
        case PRODUCT_TYPE_IDS.LEADS:
          return getSafeDivision(row?.lead_analytic_total_won, row?.lead_analytic_total_searches);
        case PRODUCT_TYPE_IDS.CALLS:
          return getSafeDivision(row?.call_analytic_total_calls, row?.call_analytic_total_searches);
        default:
          return 0;
      }
    }

    // (no-op placeholder removed)

    const updatedCampaignStats = filteredCampaignsList?.map((item) => {
      const matchingAgg = Array.isArray(qf_agg_campaigns_data)
        ? qf_agg_campaigns_data.find((d) => d?.campaign_id === item?.id)
        : undefined;
      if (matchingAgg) {
        // Preserve existing field names but source from aggregated API
        item['leads_generated_count'] = Number(matchingAgg.total_leads) || 0;
        item['calls_generated_count'] = Number(matchingAgg.total_calls) || 0;

        // Map click analytics fields from aggregated dataset
        const normalizeRate = (val) => {
          const n = parseFloat(val);
          if (!isFinite(n)) return 0;
          return n > 1 ? n / 100 : n;
        };
        item['click_analytic_total_inventory'] = Number(matchingAgg.total_inventory) || 0;
        item['click_analytic_total_opportunities'] = Number(matchingAgg.total_opportunities) || 0;
        item['click_analytic_total_searches'] = Number(matchingAgg.total_bids) || 0;
        item['searches'] = item['click_analytic_total_searches'];
        item['click_analytic_impressions'] = Number(matchingAgg.total_impressions) || 0;
        item['click_analytic_total_clicks'] = Number(matchingAgg.total_clicks) || 0;
        item['total_units'] = item['click_analytic_total_clicks'];
        item['click_analytic_total_cost'] = parseFloat(matchingAgg.total_spend) || 0;
        // Spend column uses 'total_cost' as dataField
        item['total_cost'] = item['click_analytic_total_cost'];
        item['click_analytic_avg_bid'] = parseFloat(matchingAgg.avg_bid) || 0;
        item['avg_bid'] = item['click_analytic_avg_bid'];
        item['click_analytic_avg_cpc'] = parseFloat(matchingAgg.avg_cpc) || 0;
        item['avg_unit_cost'] = item['click_analytic_avg_cpc'];
        // Use API value as-is; formatter will handle percent scaling
        item['click_analytic_target_rate'] = parseFloat(matchingAgg.target_rate) || 0;
        item['click_analytic_bid_rate'] = normalizeRate(matchingAgg.bid_rate);
        // Prefer API-provided rates if present; otherwise compute sensible fallbacks
        item['click_analytic_success_rate'] =
          matchingAgg.click_rate !== undefined && matchingAgg.click_rate !== null
            ? normalizeRate(matchingAgg.click_rate)
            : (function () {
                const clicks = Number(matchingAgg.total_clicks) || 0;
                const impressions = Number(matchingAgg.total_impressions) || 0;
                return impressions ? clicks / impressions : 0;
              })();
        item['click_analytic_win_rate'] =
          matchingAgg.win_rate !== undefined && matchingAgg.win_rate !== null
            ? normalizeRate(matchingAgg.win_rate)
            : (function () {
                const numerator = ff_user_new_win_rate
                  ? (Number(matchingAgg.total_clicks) || 0)
                  : (Number(matchingAgg.total_impressions) || 0);
                const denom = Number(matchingAgg.total_bids) || 0;
                return denom ? numerator / denom : 0;
              })();
      }
      const matchingMarketplaceAgg = goal_marketplace_flag_active && Array.isArray(marketplace_agg_campaigns_data)
        ? marketplace_agg_campaigns_data.find((d) => d?.campaign_id === item?.id)
        : undefined;
      if (matchingMarketplaceAgg) {
        // Goal Marketplace (leads) rows source the lead_analytic_* contract from
        // the v4 marketplace endpoint. Rates are already percentages (matching the
        // legacy leads format), so they are assigned as-is.
        item['lead_analytic_total_inventory'] = Number(matchingMarketplaceAgg.lead_analytic_total_inventory) || 0;
        item['lead_analytic_total_opportunities'] = Number(matchingMarketplaceAgg.lead_analytic_total_opportunities) || 0;
        item['lead_analytic_total_searches'] = Number(matchingMarketplaceAgg.lead_analytic_total_searches) || 0;
        item['searches'] = item['lead_analytic_total_searches'];
        item['lead_analytic_total_won'] = Number(matchingMarketplaceAgg.lead_analytic_total_won) || 0;
        item['lead_analytic_total_leads'] = Number(matchingMarketplaceAgg.lead_analytic_total_leads) || 0;
        item['lead_analytic_avg_bid'] = parseFloat(matchingMarketplaceAgg.lead_analytic_avg_bid) || 0;
        item['avg_bid'] = item['lead_analytic_avg_bid'];
        item['lead_analytic_total_cost'] = parseFloat(matchingMarketplaceAgg.lead_analytic_total_cost) || 0;
        item['lead_analytic_avg_cpl'] = parseFloat(matchingMarketplaceAgg.lead_analytic_avg_cpl) || 0;
        item['avg_unit_cost'] = item['lead_analytic_avg_cpl'];
        item['lead_analytic_target_rate'] = parseFloat(matchingMarketplaceAgg.lead_analytic_target_rate) || 0;
        item['lead_analytic_bid_rate'] = parseFloat(matchingMarketplaceAgg.lead_analytic_bid_rate) || 0;
        item['lead_analytic_win_rate'] = parseFloat(matchingMarketplaceAgg.lead_analytic_win_rate) || 0;
        item['lead_analytic_success_rate'] = parseFloat(matchingMarketplaceAgg.lead_analytic_success_rate) || 0;
        item['leads_generated_count'] = item['lead_analytic_total_leads'];
        item['total_units'] = item['lead_analytic_total_leads'];
        item['total_cost'] = item['lead_analytic_total_cost'];
      }
      const custom_click_analytic_bid = parseFloat(item?.[total_stat_objects.click_analytic_total_searches] || 0) * parseFloat(item?.[calculation_stat_objecs.click_analytic_avg_bid] || 0);
      const custom_call_analytic_bid = parseFloat(item?.[total_stat_objects.call_analytic_total_searches] || 0) * parseFloat(item?.[calculation_stat_objecs.call_analytic_avg_bid] || 0);
      const custom_lead_analytic_bid = parseFloat(item?.[total_stat_objects.lead_analytic_total_searches] || 0) * parseFloat(item?.[calculation_stat_objecs.lead_analytic_avg_bid] || 0);
      const bid = parseFloat(item?.[total_stat_objects.searches] || 0) * parseFloat(item?.[calculation_stat_objecs.avg_bid] || 0);
      extra_stats[calculation_stat_objecs.custom_click_analytic_bid].push(custom_click_analytic_bid);
      extra_stats[calculation_stat_objecs.custom_call_analytic_bid].push(custom_call_analytic_bid);
      extra_stats[calculation_stat_objecs.custom_lead_analytic_bid].push(custom_lead_analytic_bid);
      extra_stats[calculation_stat_objecs.bid].push(bid);
      enable_pixel_stats.forEach((stat) => {
        total_stats[stat].push(item?.[stat] || 0);
      })
      // Aggregate all known totals for footer computation, excluding pixel stats to prevent double counting
      const pixelStatSet = new Set(enable_pixel_stats);
      Object.keys(total_stats).forEach((statKey) => {
        if (pixelStatSet.has(statKey)) return;
        const value = item?.[statKey];
        const numeric = Number(value);
        total_stats[statKey].push(isFinite(numeric) ? numeric : 0);
      });
      item['win_rate'] = new_campaign_page_feature_flag_active ? getWinRateV2(item) : getWinRate(item)
      return item;
    });

    // Calculate total_bids_won and total_searches AFTER data is populated
    const total_bids_won = updatedCampaignStats
      .map((campaign) => {
        const clicks = ff_user_new_win_rate 
          ? (new_campaign_page_feature_flag_active ? campaign.click_analytic_total_clicks : campaign.click_analytic_clicks)
          : campaign.click_analytic_impressions;
        return (clicks || 0) + (campaign.lead_analytic_total_won || 0) + (campaign.call_analytic_total_calls || 0);
      })
      .reduce((acc, curr) => acc + curr, 0);

    const total_searches = updatedCampaignStats
      .map((campaign) => 
        (campaign.click_analytic_total_searches || campaign.click_analytic_searches || 0) + 
        (campaign.lead_analytic_total_searches || 0) + 
        (campaign.call_analytic_total_searches || 0)
      )
      .reduce((acc, curr) => acc + curr, 0);

    const new_stats = (Object.entries({ ...total_stats, ...extra_stats }) || []).map((stat) => {
      const [key, value] = stat;
      const total = value.reduce((acc, curr) => acc + parseFloat(curr), 0);
      return { [key]: total };
    }).reduce((prevAccum, curVal) => ({ ...prevAccum, ...curVal }), {})

    const aggregatedPixelDenominator = selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS
      ? new_stats[total_stat_objects.click_analytic_total_clicks]
      : new_stats[total_stat_objects.total_units];

    activeConversionPixels.forEach((pixel) => {
      const pixel_stat_name = `${pixel.id}:${pixel.name}`;
      const pixel_stat_name_cvr = `${pixel.id}:${pixel.name} CVR`;
      const pixel_stat_name_cpa = `${pixel.id}:${pixel.name} CPA`;
      const pixel_stat_name_rev = `${pixel.id}:${pixel.name} Rev`;
      const pixel_stat_name_roas = `${pixel.id}:${pixel.name} ROAS`;

      new_stats[pixel_stat_name_cvr] = !!new_stats[pixel_stat_name] ? getSafePercentage(new_stats[pixel_stat_name], aggregatedPixelDenominator) : 0;
      if (!!new_stats[total_stat_objects.total_cost]) {
        new_stats[pixel_stat_name_cpa] = !!new_stats[pixel_stat_name] ? (new_stats[total_stat_objects.total_cost]) / (new_stats[pixel_stat_name]) : 0;
        new_stats[pixel_stat_name_roas] = !!new_stats[pixel_stat_name] ? (new_stats[pixel_stat_name_rev]) / (new_stats[total_stat_objects.total_cost]) : 0;
      }
    });

    new_stats[calculation_stat_objecs.call_analytic_target_rate] = getSafePercentage(new_stats[total_stat_objects.call_analytic_total_opportunities], new_stats[total_stat_objects.call_analytic_total_inventory]);
    new_stats[calculation_stat_objecs.call_analytic_bid_rate] = getSafePercentage(new_stats[total_stat_objects.call_analytic_total_searches], new_stats[total_stat_objects.call_analytic_total_opportunities]);
    new_stats[calculation_stat_objecs.call_analytic_success_rate] = getSafePercentage(new_stats[total_stat_objects.call_analytic_total_accepted], new_stats[total_stat_objects.call_analytic_total_calls]);
    new_stats[calculation_stat_objecs.lead_analytic_target_rate] = getSafePercentage(new_stats[total_stat_objects.lead_analytic_total_opportunities], new_stats[total_stat_objects.lead_analytic_total_inventory]);
    new_stats[calculation_stat_objecs.lead_analytic_bid_rate] = getSafePercentage(new_stats[total_stat_objects.lead_analytic_total_searches], new_stats[total_stat_objects.lead_analytic_total_opportunities]);
    new_stats[calculation_stat_objecs.lead_analytic_success_rate] = getSafePercentage(new_stats[total_stat_objects.lead_analytic_total_leads], new_stats[total_stat_objects.lead_analytic_total_won]);
    new_stats[calculation_stat_objecs.click_analytic_target_rate] = getSafePercentage(new_stats[total_stat_objects.click_analytic_total_opportunities], new_stats[total_stat_objects.click_analytic_total_inventory]);
    new_stats[calculation_stat_objecs.click_analytic_bid_rate] = getSafePercentage(new_stats[total_stat_objects.click_analytic_total_searches], new_stats[total_stat_objects.click_analytic_total_opportunities]);
    new_stats[calculation_stat_objecs.click_analytic_success_rate] = getSafePercentage(new_stats[total_stat_objects.click_analytic_total_clicks], new_stats[total_stat_objects.click_analytic_impressions]);
    new_stats[total_stat_objects.contribution_margin] = getSafePercentage(new_stats[total_stat_objects.profit], new_stats[total_stat_objects.profit] + new_stats[total_stat_objects.total_cost]);
    new_stats[calculation_stat_objecs.click_analytic_prefill_success_rate] = getSafePercentage(totalPrefillSuccessValues, (new_campaign_page_feature_flag_active ? new_stats[total_stat_objects.click_analytic_total_clicks] : new_stats[total_stat_objects.click_analytic_clicks]));
    new_stats[calculation_stat_objecs.win_rate] = getSafePercentage(total_bids_won, total_searches)
    // CPC GROUP
    const aggregatedUnitsForCpc = selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS
      ? new_stats[total_stat_objects.click_analytic_total_clicks] //TODO: Remove this check once legacy campaign data is also sourced exclusively from agg campaigns data table.
      : new_stats[total_stat_objects.total_units];
    const analytic_cpc = getSafeDivision(new_stats[total_stat_objects.total_cost], aggregatedUnitsForCpc)
    new_stats[total_stat_objects.click_analytic_cpc] = analytic_cpc;
    new_stats[total_stat_objects.click_analytic_avg_cpc] = analytic_cpc;
    new_stats[calculation_stat_objecs.call_analytic_avg_cpc] = analytic_cpc;
    new_stats[calculation_stat_objecs.lead_analytic_avg_cpl] = analytic_cpc;
    new_stats[total_stat_objects.avg_unit_cost] = analytic_cpc;
    // AVG BID GROUP
    new_stats[calculation_stat_objecs.avg_bid] = getSafeDivision(new_stats[calculation_stat_objecs.bid], new_stats[total_stat_objects.searches]);
    new_stats[calculation_stat_objecs.click_analytic_avg_bid] = getSafeDivision(new_stats[calculation_stat_objecs.custom_click_analytic_bid], new_stats[total_stat_objects.click_analytic_total_searches]);
    new_stats[calculation_stat_objecs.call_analytic_avg_bid] = getSafeDivision(new_stats[calculation_stat_objecs.custom_call_analytic_bid], new_stats[total_stat_objects.call_analytic_total_searches]);
    new_stats[calculation_stat_objecs.lead_analytic_avg_bid] = getSafeDivision(new_stats[calculation_stat_objecs.custom_lead_analytic_bid], new_stats[total_stat_objects.lead_analytic_total_searches]);

    // TOTAL PIXEL CONVERSIONS AND REVENUE
    const calculateTotal = (stats, property) => 
      stats?.reduce((total, campaign) => total + (Number(campaign[property]) || 0), 0);
    
    new_stats[calculation_stat_objecs.total_conversions] = calculateTotal(updatedCampaignStats, 'total_conversions');
    new_stats[calculation_stat_objecs.total_revenue] = calculateTotal(updatedCampaignStats, 'total_revenue');
    return { combinedCampaignsStats: updatedCampaignStats, footerStats: new_stats };
  }, [filteredCampaignsList, qf_agg_campaigns_data, marketplace_agg_campaigns_data, goal_marketplace_flag_active, activeConversionPixels, selectedProductGroup?.value])

  const getDailyBudgetTypeOptions = ((productType, account) => {
    if (account && !account.enterprise && (productType === NAME_OF_PRODUCT_TYPES.CALLS || productType === NAME_OF_PRODUCT_TYPES.LEADS)) {
      return DailyBudgetTypeRetailCallLeads;
    } else {
      return DailyBudgetType;
    }

  });

  const DailyBudgetTypeRetailCallLeads = [
    {
      label: '',
      options: getBudgetOptionsForAccount(current_account),
    },
  ];

  useEffect(
    () => handleSessionTimeOut(error, history),
    [error],
  );

  const [selectedDateRange, setSelectedDateRange] = useState(() => {
    const storedDateRange = bsh_getFilters(STORAGE_KEY.FILTERS.CAMPAIGN, CAMPAIGN_FILTERS.DATE_RANGE);
    if (storedDateRange?.original_label === DATE_RANGE_OPTIONS.CUSTOM_RANGE) {
      const startDate = storedDateRange?.value?.startDate ? new Date(storedDateRange.value.startDate) : null;
      const endDate = storedDateRange?.value?.endDate ? new Date(storedDateRange.value.endDate) : null;
      return {
        label: createLabelWithDateRange({ label: DATE_RANGE_OPTIONS_DISPLAY.CUSTOM_RANGE, startDate, endDate }),
        value: {
          startDate,
          endDate,
        },
        original_label: DATE_RANGE_OPTIONS.CUSTOM_RANGE,
        timezone: getIANATimezoneStringForAbbreviation(current_account?.timezone),
      };
    }
    return storedDateRange ? changeOptionValueToDateObject(storedDateRange) : createOption(
      DATE_RANGE_OPTIONS.THIS_MONTH,
      new Date(),
      getIANATimezoneStringForAbbreviation(current_account?.timezone),
    );
  });

  const [urlFilters, setUrlFilters] = useState([
    { name: 'status', value: selectedStatusGroup.value },
    { name: 'product', value: selectedProductGroup.value },
    { name: 'brands', value: selectedBrands?.length ? selectedBrands : OPTION_ALL },
    { name: 'lead_type', value: selectedLeadGroup.value },
    { name: 'date_range', value: selectedDateRange?.original_label === DATE_RANGE_OPTIONS.CUSTOM_RANGE ? { startDate: selectedDateRange?.value?.startDate, endDate: selectedDateRange?.value?.endDate } : selectedDateRange?.original_label },
  ])

  useEffect(() => {
    if (!campaigns?.length) {
      return
    }
    let campaignProductTypes = campaigns.map((campaign, index, array) => {
      return {
        label: getCampaignProductLabel(campaign.product_type.name, goal_marketplace_flag_active),
        value: campaign.product_type.name,
        id: campaign.product_type.id
      }
    })
    if (!isClicksProductEnabled) {
      campaignProductTypes = campaignProductTypes.filter((productType) => productType.value !== NAME_OF_PRODUCT_TYPES.CLICKS)
    }
    const uniqueProductTypesFromCampaigns = _.sortBy(_.uniqBy(campaignProductTypes, 'id'), 'id')
    const productTypes = [...uniqueProductTypesFromCampaigns]
    if (productTypes.length > 1) {
      productTypes.unshift({ label: 'All', value: '' })
    }
    setOptionsCampaignProducts(productTypes);
  }, [campaigns, isClicksProductEnabled, goal_marketplace_flag_active])

  useEffect(() => {
    if (brands && brands?.length) {
      const brandsOptions = brands.map(el => ({
        label: el.name,
        value: el.name,
      }))
      const updatedOptions = [OPTION_ALL, ...brandsOptions];
      setBrandsOptions(updatedOptions)
    }
  }, [brands]);

  useEffect(() => {
    if (!campaigns?.length) {
      setSelectedProductGroup(bsh_getFilters(STORAGE_KEY.FILTERS.CAMPAIGN, CAMPAIGN_FILTERS.PRODUCT) || { label: 'All', value: '' })
    }
    if (optionsCampaignProducts?.length === 1) {
      setSelectedProductGroup(bsh_getFilters(STORAGE_KEY.FILTERS.CAMPAIGN, CAMPAIGN_FILTERS.PRODUCT) || optionsCampaignProducts[0])
    }
    if (optionsCampaignProducts?.length > 1) {
      setSelectedProductGroup(bsh_getFilters(STORAGE_KEY.FILTERS.CAMPAIGN, CAMPAIGN_FILTERS.PRODUCT) || optionsCampaignProducts[0])
    }
  }, [campaigns, optionsCampaignProducts])

  useEffect(() => {

    let optionLeadTypesStateNew = []
    if (selectedProductGroup.value === NAME_OF_PRODUCT_TYPES.CALLS) {
      optionLeadTypesStateNew = [
        {
          label: 'Insurance Type',
          options: LEAD_TYPE_OPTIONS[0].options
        },
      ];
      setOptionLeadTypesState(optionLeadTypesStateNew);
    }
    else if (selectedProductGroup.value === NAME_OF_PRODUCT_TYPES.LEADS || selectedProductGroup.value === NAME_OF_PRODUCT_TYPES.CLICKS) {
      optionLeadTypesStateNew = [
        {
          label: 'Insurance Type',
          options: LEAD_TYPE_OPTIONS[0].options.filter((lead_type) => lead_type.value !== NAME_OF_LEAD_TYPES.P_C_BUNDLE)
        },
      ];
      setOptionLeadTypesState(optionLeadTypesStateNew);
    }
    else if (selectedProductGroup.value === NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS || selectedProductGroup.value === NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS) {
      optionLeadTypesStateNew = [
        {
          label: 'Insurance Type',
          options: LEAD_TYPE_OPTIONS[0].options.filter((lead_type) => lead_type.value !== NAME_OF_LEAD_TYPES.P_C_BUNDLE)
        },
      ];
      setOptionLeadTypesState(optionLeadTypesStateNew);
    }
    else {
      setOptionLeadTypesState(LEAD_TYPE_OPTIONS);
    }
   
    const newSelectedLeadGroup = selectedProductGroup?.value !== NAME_OF_PRODUCT_TYPES.CALLS && selectedLeadGroup?.value === NAME_OF_LEAD_TYPES.P_C_BUNDLE ?
      optionLeadTypesStateNew[0]?.options[0] :
      bsh_getFilters(STORAGE_KEY.FILTERS.CAMPAIGN, CAMPAIGN_FILTERS.LEAD_TYPE) || optionLeadTypesStateNew[0]?.options[0];
    
    // Only update selectedLeadGroup if it's different from the current value
    if (newSelectedLeadGroup?.value !== selectedLeadGroup?.value) {
      setSelectedLeadGroup(newSelectedLeadGroup);
      // Move the updateUrlFilters call inside this condition to prevent unnecessary updates
      updateUrlFilters(CAMPAIGN_FILTERS.LEAD_TYPE, newSelectedLeadGroup?.value);
    }

    selectedProductGroup && productTypeFilter && (productTypeFilter(selectedProductGroup.value));
    
  }, [selectedProductGroup]);

  const applyFilters = () => {
    selectedProductGroup && productTypeFilter && (productTypeFilter(selectedProductGroup.value));
    if (selectedLeadGroup && leadTypeFilter) {
      leadTypeFilter(selectedLeadGroup.value);
    }
    selectedStatusGroup && statusFilter && (statusFilter(selectedStatusGroup.value));
    selectedName && nameFilter && (nameFilter(selectedName));
  }

  useEffect(() => {
    if (selectedLeadGroup && leadTypeFilter) {
      leadTypeFilter(selectedLeadGroup.value);
    }
  }, [selectedLeadGroup]);

  useEffect(() => {
    selectedStatusGroup && statusFilter && (statusFilter(selectedStatusGroup.value));
  }, [selectedStatusGroup]);

  const includeDiscardedCampaignsFF = isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_INCLUDE_DISCARDED_CAMPAIGNS);
  const lastStatsFetchRef = useRef({ label: null, startDate: null, endDate: null });
  // What this mount last asked for, kept only to stop a failed request from being retried on the
  // spot: the reducer clears the redux record when a request fails, which would otherwise read as
  // "nothing fetched yet" and dispatch again immediately. A remount clears this, so the range is
  // attempted again when the user comes back to the page. (BM-9197)
  const lastAttemptedFetchRef = useRef(null);
  const normalizeDateForComparison = (value) => {
    if (!value) return null;
    const dateObj = value instanceof Date ? value : new Date(value);
    const timestamp = dateObj.valueOf();
    return Number.isNaN(timestamp) ? null : dateObj.toISOString();
  };

  const areDateRangesEqual = (rangeA, rangeB) => {
    if (!rangeA || !rangeB) {
      return false;
    }
    if (rangeA.original_label !== rangeB.original_label) {
      return false;
    }
    if (rangeA.original_label !== DATE_RANGE_OPTIONS.CUSTOM_RANGE) {
      return true;
    }
    const startA = normalizeDateForComparison(rangeA?.value?.startDate);
    const startB = normalizeDateForComparison(rangeB?.value?.startDate);
    const endA = normalizeDateForComparison(rangeA?.value?.endDate);
    const endB = normalizeDateForComparison(rangeB?.value?.endDate);
    return startA === startB && endA === endB;
  };

  useEffect(() => {
    // `includeDiscardedCampaignsFF` reads false until the flags response lands. Fetching before then
    // would record the range as fetched while omitting start_date/end_date, and the flag flipping on
    // afterwards is not a range change — so the correctly parameterized request would never be sent.
    // Wait for the flags, same as the stats effect below. (BM-9197)
    if (!areFeatureFlagsLoaded) {
      return;
    }

    const currentLabel = selectedDateRange?.original_label;
    const isCustomRange = currentLabel === DATE_RANGE_OPTIONS.CUSTOM_RANGE;
    const currentStart = isCustomRange ? normalizeDateForComparison(selectedDateRange?.value?.startDate) : null;
    const currentEnd = isCustomRange ? normalizeDateForComparison(selectedDateRange?.value?.endDate) : null;

    // Compare against the range redux says was last requested, not a mount-local ref: the campaigns
    // already in the store may have been fetched by `App.js` before this page mounted.
    const alreadyFetched = isCustomRange
      ? (
        last_fetch_all_campaigns_time_frame_key === DATE_RANGE_OPTIONS.CUSTOM_RANGE &&
        normalizeDateForComparison(last_fetch_all_campaigns_custom_date_range?.start_date) === currentStart &&
        normalizeDateForComparison(last_fetch_all_campaigns_custom_date_range?.end_date) === currentEnd
      )
      : last_fetch_all_campaigns_time_frame_key === currentLabel;

    if (alreadyFetched) {
      return;
    }

    // Hold off only when the range we need is the one that just failed, and this mount is what asked
    // for it — dispatching again here would go straight back into the same failure. A failure of some
    // other caller's request (`App.js` can be on a different range entirely) says nothing about ours,
    // and must not stop us from fetching. Retry happens on remount or when the range changes, since
    // the ref is what makes this specific to our own attempt.
    const fetchSignature = `${currentLabel}|${currentStart || ''}|${currentEnd || ''}`;
    const failedFetch = last_failed_all_campaigns_fetch;
    const ourRangeJustFailed = !!failedFetch
      && failedFetch.time_frame_key === currentLabel
      && normalizeDateForComparison(failedFetch.start_date) === currentStart
      && normalizeDateForComparison(failedFetch.end_date) === currentEnd;

    if (ourRangeJustFailed && lastAttemptedFetchRef.current === fetchSignature) {
      return;
    }

    const dateRangeValue = _.cloneDeep(selectedDateRange.value);
    const queryParams = {};

    if (includeDiscardedCampaignsFF) {
      if (dateRangeValue?.startDate) {
        const startValue = dateRangeValue.startDate instanceof Date ? dateRangeValue.startDate : new Date(dateRangeValue.startDate);
        queryParams.start_date = startValue.toISOString();
      }
      if (dateRangeValue?.endDate) {
        const endValue = dateRangeValue.endDate instanceof Date ? dateRangeValue.endDate : new Date(dateRangeValue.endDate);
        queryParams.end_date = endValue.toISOString();
      }
    }

    lastAttemptedFetchRef.current = fetchSignature;
    dispatch(getCampaigns({
      queryParams,
      time_frame_key: currentLabel,
      // recorded separately from `queryParams` so the range is known even while the feature flag
      // above keeps the dates out of the request
      fetched_range: { start_date: currentStart, end_date: currentEnd },
    }));
  }, [
    selectedDateRange,
    includeDiscardedCampaignsFF,
    areFeatureFlagsLoaded,
    last_fetch_all_campaigns_time_frame_key,
    last_fetch_all_campaigns_custom_date_range,
    last_failed_all_campaigns_fetch,
  ]);

  useEffect(() => {
    if (!areFeatureFlagsLoaded) {
      return;
    }

    const currentLabel = selectedDateRange?.original_label;
    const isCustomRange = currentLabel === DATE_RANGE_OPTIONS.CUSTOM_RANGE;
    const currentStart = isCustomRange ? normalizeDateForComparison(selectedDateRange?.value?.startDate) : null;
    const currentEnd = isCustomRange ? normalizeDateForComparison(selectedDateRange?.value?.endDate) : null;
    const prevFetch = lastStatsFetchRef.current;

    const hasRangeChanged = isCustomRange
      ? (
        prevFetch.label !== DATE_RANGE_OPTIONS.CUSTOM_RANGE ||
        prevFetch.startDate !== currentStart ||
        prevFetch.endDate !== currentEnd
      )
      : prevFetch.label !== currentLabel;

    if (!hasRangeChanged) {
      return;
    }

    const dateRangeValue = _.cloneDeep(selectedDateRange.value);
    const queryParams = {};
    const v4QueryParams = {}; // Separate params for v4 API

    // Format dates normally for v1 API (with timezone/ISO format)
    if (dateRangeValue?.startDate) {
      queryParams.start_date = dateRangeValue?.startDate instanceof Date ? dateRangeValue.startDate.toISOString() : dateRangeValue.startDate;
      // Format as the selected reporting date for v4 API.
      v4QueryParams.start_date = formatDatePST(dateRangeValue.startDate);
    }
    if (dateRangeValue?.endDate) {
      queryParams.end_date = dateRangeValue.endDate instanceof Date ? dateRangeValue.endDate.toISOString() : dateRangeValue.endDate;

      // Format as the selected reporting date for v4 API. The backend treats
      // this inclusive date as a half-open range through the following date.
      v4QueryParams.end_date = formatDatePST(dateRangeValue.endDate);
    }

    const hasClicksOrSyndiOrQf = hasClicks || hasSyndiClicks || hasQuoteFunnels;
    const hasProductTypesToFetch = hasQuoteFunnels || hasClicksOrSyndiOrQf || hasLeads || hasCalls;

    if (!hasProductTypesToFetch) {
      return;
    }

    if (hasQuoteFunnels) {
      dispatch(getAggQuoteFunnelsStatsForCampaigns(v4QueryParams));
    }

    if (hasLeads && goal_marketplace_flag_active) {
      dispatch(getAggMarketplaceStatsForCampaigns(v4QueryParams));
    }

    if (use_v3_api_for_campaign_conversion_stats) {
      dispatch(getConversionPixelsAggCampaignsV3({ queryParams }));
    } else {
      if (hasClicksOrSyndiOrQf) {
        dispatch(getClickConversionPixelsAggCampaigns({ queryParams }));
      }

      if (show_pixel_stats_for_leads_and_calls) {
        if (hasLeads) {
          dispatch(getLeadConversionPixelsAggCampaigns({ queryParams }));
        }
        if (hasCalls) {
          dispatch(getCallConversionPixelsAggCampaigns({ queryParams }));
        }
      }
    }

    lastStatsFetchRef.current = {
      label: currentLabel,
      startDate: currentStart,
      endDate: currentEnd,
    };
  }, [selectedDateRange, distinctProductTypes, new_campaign_page_feature_flag_active, use_v3_api_for_campaign_stats, use_v3_api_for_campaign_conversion_stats, areFeatureFlagsLoaded]);

  //For disabling dropdown on clicking outside
  const closeDropdown = (e) => {
    if (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_ALLOW_DROPDOWN_CLOSE)) {
      return
    }
    setIsTextSelected(false);
    if (e.target.classList.contains("sf_dropdown_popup__option")) {
      return // Return if an option is clicked. Take no further action
    }

    const domCampaignName = ReactDOM.findDOMNode(dropdownMenuRefCampaignName.current)
    if (dropdownMenuRefCampaignName.current && (!domCampaignName.innerHTML.toString().replace(/(<([^>]+)>)/ig, '').includes(e.target.innerHTML.toString().replace(/(<([^>]+)>)/ig, '')))) {
      setIsEditingName(null);
    }

    const domCampaignDayLimits = ReactDOM.findDOMNode(dropdownMenuRefCampaignDayLimits.current)
    if (dropdownMenuRefCampaignDayLimits.current && (!domCampaignDayLimits.innerHTML.toString().replace(/(<([^>]+)>)/ig, '').includes(e.target.innerHTML.toString().replace(/(<([^>]+)>)/ig, '')))) {
      setIsEditingDailyBudget(null);
    }

    const domCampaignMonthLimits = ReactDOM.findDOMNode(dropdownMenuRefCampaignMonthLimits.current)
    if (dropdownMenuRefCampaignMonthLimits.current && (!domCampaignMonthLimits.innerHTML.toString().replace(/(<([^>]+)>)/ig, '').includes(e.target.innerHTML.toString().replace(/(<([^>]+)>)/ig, '')))) {
      setIsEditingMonthlyBudget(null);
    }
  };

  const handleSelectedBrands = (selectedOption, event) => {
    const updatedBrands = getUpdatedOptionsFromEvent(selectedOption, event, brandsOptions)

    setSelectedBrands(updatedBrands);
    updateUrlFilters(CAMPAIGN_FILTERS.BRANDS, updatedBrands);
    bsh_setFilters(STORAGE_KEY.FILTERS.CAMPAIGN, CAMPAIGN_FILTERS.BRANDS, updatedBrands);
  };

  const onClickOpenNotes = (campaign_id) => {
    const notes = getNotesGroupByCampaignId(campaign_id);
    setCampaignNoteModal({ action: true, notes: notes, campaign_id: campaign_id });
  }

  const onSubmitCampaignNoteModal = (modalState) => {
    const data = {
      campaign_note: {
        text: modalState?.text,
        campaign_id: modalState?.campaign_id,
      }
    }
    dispatch(createCampaignNotes(data));
  }

  // notes formatter
  const notesFormatter = (cell, row, rowIndex, campaign_notes_loading) => {
    return (
      <div className="d-flex align-items-center">
        {(campaign_notes_loading ? <Skeleton /> :
          <a onClick={() => onClickOpenNotes(row?.id)} className='text-sfblue'>{(`(${getNotesCountByCampaignId(row?.id)})` + (getNotesCountByCampaignId(row?.id) > 1 ? " Notes" :
            " Note"))}</a>)}
      </div>
    );
  }

  useEffect(() => {
    if (!campaigns?.length) {
      setCampaignsList([]);
      return;
    }
    const pixelColumns = createPixelColumns({
      activeConversionPixels,
      new_campaign_page_feature_flag_active,
      selectedProductGroup,
      show_pixel_stats_for_leads_and_calls,
      loading: {
        click_conversion_pixels_aggregated_loading,
        lead_conversion_pixels_agg_loading,
        call_conversion_pixels_agg_loading
      },
      roas_column_show_ff
    })

    if ((isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_PIXEL_STATS_FOR_CAMPAIGNS))) {
      setDynamicColumns(pixelColumns);
    }

    const campaignsWithPixelData = campaigns.map(campaign => {
      const [
        conversions_count_type,
        analytics_leads_type,
        analytics_payout_type,
        conversions_revenue_type
      ] = getMetricNamesForPixelStats(show_pixel_stats_for_leads_and_calls ? campaign?.product_type?.name :
        NAME_OF_PRODUCT_TYPES.CLICKS, new_campaign_page_feature_flag_active)

      const isGoalMarketplaceLead = goal_marketplace_flag_active &&
        campaign?.product_type?.name === NAME_OF_PRODUCT_TYPES.LEADS
      const marketplaceAggData = isGoalMarketplaceLead && Array.isArray(marketplace_agg_campaigns_data)
        ? marketplace_agg_campaigns_data.find(agg => agg?.campaign_id === campaign.id)
        : undefined
      const campaignAggData = qf_agg_campaigns_data.find(agg => agg.campaign_id === campaign.id)

      let total_conversions = 0
      let total_revenue = 0

      const pixelColValuesForCampaigns = activeConversionPixels.map(pixel => {
        let pixel_stats_from_agg = {}
        if (show_pixel_stats_for_leads_and_calls) {
          if (campaign?.product_type?.name === NAME_OF_PRODUCT_TYPES.CLICKS || campaign?.product_type?.name === NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS || campaign?.product_type?.name === NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS) {
            pixel_stats_from_agg = click_conversion_pixels_agg_campaigns.find(
              px => pixel.id === px.id && campaign.id === px.campaign_id
            )
          } else if (campaign?.product_type?.name === NAME_OF_PRODUCT_TYPES.LEADS) {
            pixel_stats_from_agg = lead_conversion_pixels_agg_campaigns.find(
              px => pixel.id === px.id && campaign.id === px.campaign_id
            )
          } else if (campaign?.product_type?.name === NAME_OF_PRODUCT_TYPES.CALLS) {
            pixel_stats_from_agg = call_conversion_pixels_agg_campaigns.find(
              px => pixel.id === px.id && campaign.id === px.campaign_id
            )
          }
        } else {
          pixel_stats_from_agg = click_conversion_pixels_agg_campaigns.find(
            px => pixel.id === px.id && campaign.id === px.campaign_id
          )
        }

        try {
          const qfTotalClicks = Number(campaignAggData?.total_clicks);
          const qfClicks = Number.isFinite(qfTotalClicks) ? qfTotalClicks : campaign?.click_analytic_total_clicks;
          // TODO: Remove this fallback once legacy campaign data is also sourced exclusively from qf_agg_campaigns_data.
          // At that point, Quote Funnels CVR should always divide by qfClicks and never rely on analytics_leads_type.
          const effectiveDenominator = (campaign?.product_type?.name === NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS && Number.isFinite(qfClicks) && qfClicks !== 0)
            ? qfClicks
            : isGoalMarketplaceLead
              ? marketplaceAggData?.lead_analytic_total_leads ?? campaign?.[analytics_leads_type]
              : campaign?.[analytics_leads_type];
          const {
            conversionCount,
            cvr,
            cpa,
            revenue,
            roas,
          } = getCampaignPixelMetricValues({
            campaign,
            campaignAggData,
            marketplaceAggData,
            isGoalMarketplaceLead,
            pixelStats: pixel_stats_from_agg,
            conversionsCountType: conversions_count_type,
            denominator: effectiveDenominator,
            conversionsRevenueType: conversions_revenue_type,
          })
          total_conversions = addNumbersSafely(total_conversions, conversionCount)
          total_revenue = addNumbersSafely(total_revenue, revenue)
          return {
            [`${pixel.id}:${pixel.name}`]:
              conversionCount,
            [`${pixel.id}:${pixel.name} CVR`]: cvr,
            [`${pixel.id}:${pixel.name} CPA`]: cpa,
            [`${pixel.id}:${pixel.name} Rev`]:
              revenue,
            'revenue': revenue,
            [`${pixel.id}:${pixel.name} ROAS`]:
              roas,
          }
        } catch (e) {
          return {};
        }
      })

      return {
        ...campaign,
        ...pixelColValuesForCampaigns.reduce((prevAccum, curVal) => ({ ...prevAccum, ...curVal }), {}),
        // Note: getProfit and getMargin still use analytics_payout_type for backward compatibility
        // These functions will need to be updated when fully migrating to qf_agg_campaigns_data
        profit: getProfit(campaign, pixelColValuesForCampaigns, analytics_payout_type),
        contribution_margin: getMargin(campaign, pixelColValuesForCampaigns, analytics_payout_type),
        total_conversions: total_conversions,
        total_revenue: total_revenue
      }
    });
    setCampaignsList(campaignsWithPixelData);
    applyFilters();

  }, [
    campaigns,
    new_campaign_page_feature_flag_active,
    show_pixel_stats_for_leads_and_calls,
    selectedProductGroup,
    click_conversion_pixels,
    click_conversion_pixels_agg_campaigns,
    click_conversion_pixels_aggregated_loading,
    lead_conversion_pixels_agg_campaigns,
    call_conversion_pixels_agg_campaigns,
    activeConversionPixels,
    qf_agg_campaigns_data,
    marketplace_agg_campaigns_data,
    goal_marketplace_flag_active
  ]);

  // For rest Popup Modal State
  const resetPopupModal = () => {
    setIsEditingDailyBudget({});
    setIsEditingMonthlyBudget({});
    setIsEditingName({});
  };

  const onFilterByDateFunc = (_filterVal, data) => data;
  /*
    TODO: Use this filter later to filter campaigns by stats
    */
  // if (!filterVal) {
  //   return data;
  // }

  // return data.filter(campaign => {
  //   let campaignDate = startOfDay(new Date(campaign.created_at));

  //   if (filterVal.startDate && isBefore(campaignDate, filterVal.startDate)) {
  //     return false;
  //   }

  //   if (filterVal.endDate && isAfter(campaignDate, filterVal.endDate)) {
  //     return false;
  //   }
  //   return true
  // });


  const onBulkEdit = (selectedOption) => {
    
    // Filter out discarded campaigns from bulk operations
    const nonDiscardedRows = selectedRows.filter(row => !row.discarded_at);
    
    if (selectedOption.value === 'active') {
      for (const row of nonDiscardedRows) {
        onUpdateStatus(row, true);
      }
      setSelectedRows([]);
    }

    if (selectedOption.value === 'inactive') {
      for (const row of nonDiscardedRows) {
        onUpdateStatus(row, false);
      }
      setSelectedRows([]);
    }

    if (selectedOption.value === 'duplicate') {
      for (const row of nonDiscardedRows) {
        dispatch(duplicateCampaign(row));
      }
      setSelectedRows([]);
    }
    if (selectedOption.value === 'delete') {
      onClickBulkDeleteCampaign(nonDiscardedRows);
      setSelectedRows([]);
    }
  };


  // Logic for data table

  // For Duplicate Campaign

  const onClickDuplicateCampaign = (state) => {
    dispatch(duplicateCampaign(state));
  };

  // Delete Campaign
  const [deleteCampaignModal, setDeleteCampaignModal] = useState({ action: false, campaign: {} });
  const onClickDelete = (campaign) => {
    setDeleteCampaignModal({ action: true, campaign });
  };

  // For Bulk Delete Campaigns
  const [bulkDeleteCampaignModal, setBulkDeleteCampaignModal] = useState({ action: false, campaign: {} });
  const onClickBulkDeleteCampaign = (campaign) => {
    setBulkDeleteCampaignModal({ action: true, campaign });
  };

  const onSaveDeleteCampaign = (state) => {
    dispatch(deleteMultipleCampaign([state.campaign.id]));
    setDeleteCampaignModal({ action: false, campaign: {} });
  };

  const onSaveBulkDeleteCampaign = (selectedRows) => {
    const campaign_ids = selectedRows.campaign.map(campaign => campaign.id)
    dispatch(deleteMultipleCampaign(campaign_ids));
    setBulkDeleteCampaignModal({ action: false, campaign: {} });
  };

  // for status

  const onUpdateStatus = (state, value) => {
    // Prevent status changes for discarded campaigns
    if (state.discarded_at) {
      return;
    }
    
    const data = {
      section_name: 'type',
      lastId: state.id,
      name: state.name,
      active: value,
      lead_type: state.lead_type.name,
      product_type: state.product_type.name,
    };

    dispatch(modifyCampaign(data));
  };

  // For Name Input Eidt

  const onClickNameHandle = (state, value) => {
    // Prevent name changes for discarded campaigns
    if (state.discarded_at) {
      return false;
    }
    
    const data = {
      section_name: 'type',
      lastId: state.id,
      name: value,
      active: state.active,
      lead_type: state.lead_type.name,
      product_type: state.product_type.name,
    };
    if (value.length < 1) {
      ToastAlert.fire({ icon: ToastAlertIconType.ERROR, title: 'Campaign name cannot be blank' });
      return false;
    }

    dispatch(modifyCampaign(data));

    return true;
  };
  // For ONCLICK DAILY LIMITS
  const [budgetByDayArrayInputs, setBudgetByDayArrayInputs] = useState([...DAY_ARRARY]);
  const [selecteMonth, setSelecteMonth] = useState({ id: 1, label: 'Unlimited', value: 'Unlimited' });
  const [selectDailyLimits, setSelectDailyLimits] = useState({ id: 1, label: 'Unlimited', value: 'Unlimited' });
  const canManageCampaign = useCanManageCampaign();
  const getActivePermissions = useClientPermissionsAccess();
  const canCreateNewCampaign = !!getActivePermissions([UI_PERMISSION_KEY.MANAGE_CAMPAIGNS]).length;
  const [isProductType, setIsProductType] = useState(null);
  const [budgetAndLimitInputs, setBudgetAndLimitInputs] = useState({
    daily_limit_type: '',
    monthly_limit_type: '',
    daily_budget_units: '',
    monthly_budget_units: '',
    budget_by_day: ['', '', '', '', '', '', ''],
  });

  const handleBudgetByDayArrayInputs = (index, e) => {
    let { value } = e.target;
    value = value.replace(/[^0-9.]/g, '');
    const updatedArrByDay = budgetByDayArrayInputs.map((restValue) => {
      if (restValue.day_id === index) {
        return { ...restValue, value };
      }
      return restValue;
    });
    setBudgetByDayArrayInputs(updatedArrByDay);
  };

  const handleDailyLimits = (e) => {
    setSelectDailyLimits(e);
    setBudgetByDayArrayInputs([...DAY_ARRARY]);
    setBudgetAndLimitInputs({ ...budgetAndLimitInputs, daily_budget_units: '' });
  };
  const handleMonthlyLimits = (e) => {
    setSelecteMonth(e);
    setBudgetAndLimitInputs({ ...budgetAndLimitInputs, monthly_budget_units: '' });
  };

  const handleBudgetAndLimit = (e) => {
    let { name, value } = e.target;
    value = value.replace(/[^0-9.]/g, '');
    setBudgetAndLimitInputs({ ...budgetAndLimitInputs, [name]: value });
  };

  const onClickSaveDailyBudget = (row, _nameInput) => {
    // Prevent daily budget changes for discarded campaigns
    if (row.discarded_at) {
      return;
    }
    
    if (IsAccountRetailAndProductTypeIsLeadsOrCalls(current_account, row?.product_type?.name) && (selectDailyLimits?.value !== "Unlimited") && (budgetAndLimitInputs?.daily_budget_units < 5) && !manageBudgetsAdminPermission(bsh_isAdminUserDetailsPresent, adminPermissionPresent)) {
      return;
    }
    const daily_budget_data = [];
    if (selectDailyLimits.value === 'Unlimited') {
      for (let i = 0; i < 7; i++) {
        daily_budget_data[i] = {
          day_id: i,
          dollar_budget: INFINITY,
          modification_type: MODIFICATION_TYPE.new,
          volume_budget: INFINITY,
        };
      }
    } else if (selectDailyLimits.value === 'Daily Budget') {
      if (!budgetAndLimitInputs.daily_budget_units) {
        setVisibleAlert(true);
        return
      }
      for (let i = 0; i < 7; i++) {
        daily_budget_data[i] = {
          day_id: i,
          dollar_budget: budgetAndLimitInputs.daily_budget_units,
          modification_type: MODIFICATION_TYPE.new,
          volume_budget: null,
        };
      }
    } else if (selectDailyLimits.value === 'Daily Volume') {
      if (!budgetAndLimitInputs.daily_budget_units) {
        setVisibleAlert(true);
        return
      }
      for (let i = 0; i < 7; i++) {
        daily_budget_data[i] = {
          day_id: i,
          dollar_budget: null,
          modification_type: MODIFICATION_TYPE.new,
          volume_budget: budgetAndLimitInputs.daily_budget_units,
        };
      }
    } else if (selectDailyLimits.value === 'Budget by Day') {
      // TODO: handle cases where user doesn't leaves the field blank
      if ((!budgetByDayArrayInputs[0].value) &&
        (!budgetByDayArrayInputs[1].value) &&
        (!budgetByDayArrayInputs[2].value) &&
        (!budgetByDayArrayInputs[3].value) &&
        (!budgetByDayArrayInputs[4].value) &&
        (!budgetByDayArrayInputs[5].value) &&
        (!budgetByDayArrayInputs[6].value)) {
        for (let i = 0; i < 7; i++) {
          daily_budget_data[i] = {
            day_id: i,
            dollar_budget: INFINITY,
            modification_type: MODIFICATION_TYPE.new,
            volume_budget: INFINITY,
          };
        }
      } else {
        for (let i = 0; i < budgetByDayArrayInputs.length && i < 7; i++) {
          daily_budget_data[i] = {
            day_id: budgetByDayArrayInputs[i].day_id,
            dollar_budget: budgetByDayArrayInputs[i].value,
            modification_type: MODIFICATION_TYPE.new,
            volume_budget: null,
          };
        }
      }
    } else if (selectDailyLimits.value === 'Volume by Day') {
      if ((!budgetByDayArrayInputs[0].value) &&
        (!budgetByDayArrayInputs[1].value) &&
        (!budgetByDayArrayInputs[2].value) &&
        (!budgetByDayArrayInputs[3].value) &&
        (!budgetByDayArrayInputs[4].value) &&
        (!budgetByDayArrayInputs[5].value) &&
        (!budgetByDayArrayInputs[6].value)) {
        for (let i = 0; i < 7; i++) {
          daily_budget_data[i] = {
            day_id: i,
            dollar_budget: INFINITY,
            modification_type: MODIFICATION_TYPE.new,
            volume_budget: INFINITY,
          };
        }
      } else {
        for (let i = 0; i < budgetByDayArrayInputs.length && i < 7; i++) {
          daily_budget_data[i] = {
            day_id: budgetByDayArrayInputs[i].day_id,
            dollar_budget: null,
            modification_type: MODIFICATION_TYPE.new,
            volume_budget: budgetByDayArrayInputs[i].value,
          };
        }
      }
    }

    let daily_budget_data_with_id_info = daily_budget_data;

    daily_budget_data_with_id_info = daily_budget_data.map((daily_budget) => {
      // find campaign_budget from day_id
      const previousCampaignBudget = row.campaign_budgets.find((prevBudget) => (prevBudget.day_id == daily_budget.day_id));
      // add id to object
      // set modification_type to 'update'
      if (previousCampaignBudget) {
        return { ...daily_budget, id: previousCampaignBudget.id, modification_type: MODIFICATION_TYPE.update };
      }
      return daily_budget;
    });

    const data = {
      lastId: row.id,
      section_name: 'budget',
      monthly_budget_units: row.monthly_volume,
      monthly_dollar_budget: row.monthly_budget,
      data: daily_budget_data_with_id_info,
    };

    dispatch(modifyCampaign(data));
    setSelectDailyLimits({ id: 1, label: 'Unlimited', value: 'Unlimited' });
    setBudgetAndLimitInputs({
      daily_limit_type: '',
      monthly_limit_type: '',
      daily_budget_units: '',
      monthly_budget_units: '',
      budget_by_day: ['', '', '', '', '', '', ''],
    });
    setIsProductType(null);
    setIsEditingDailyBudget(null);
  };

  const onClickSaveMonthlyBudget = (row, _nameInput) => {
    // Prevent monthly budget changes for discarded campaigns
    if (row.discarded_at) {
      return;
    }
    
    let monthly_budget_info = {
      monthly_budget_units: null,
      monthly_dollar_budget: null,
    };

    if (selecteMonth.value === 'Monthly Budget') {
      if (!budgetAndLimitInputs.monthly_budget_units) {
        setVisibleAlert(true);
        return
      }
      monthly_budget_info = { ...monthly_budget_info, monthly_dollar_budget: budgetAndLimitInputs.monthly_budget_units };
    } else if (selecteMonth.value === 'Monthly Volume') {
      if (!budgetAndLimitInputs.monthly_budget_units) {
        setVisibleAlert(true);
        return
      }
      monthly_budget_info = { ...monthly_budget_info, monthly_budget_units: budgetAndLimitInputs.monthly_budget_units };
    } else if (selecteMonth.value === 'Unlimited') {
      monthly_budget_info = { monthly_dollar_budget: INFINITY, monthly_budget_units: INFINITY };
    }

    const data = {
      lastId: row.id,
      section_name: 'budget',
      ...monthly_budget_info,
      data: row.campaign_budgets,
    };

    dispatch(modifyCampaign(data));
    setSelecteMonth({ id: 1, label: 'Unlimited', value: 'Unlimited' });
    setBudgetAndLimitInputs({
      daily_limit_type: '',
      monthly_limit_type: '',
      daily_budget_units: '',
      monthly_budget_units: '',
      budget_by_day: ['', '', '', '', '', '', ''],
    });

    setIsEditingMonthlyBudget(null);
  };

  /**
 * Resetting last completed action because edit campaign relies on this being null initially for accordion collapse.
 */
  useEffect(() => {
    if (lastCompletedAction === MODIFY_CAMPAIGN_SUCCESS) {
      dispatch(resetLastCompletedAction());
    }
  }, [lastCompletedAction]);

  const addDollarSignIfEmpty = (e, index = 0) => {
    setIsTextSelected(false)
    if (e.target.value.length === index) {
      e.target.value = '$';
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Backspace') {
      addDollarSignIfEmpty(event, 0);
    }
  };

  let DailyLimits_HTML = '';
  switch (selectDailyLimits?.value) {
    case 'Budget by Day': DailyLimits_HTML = budgetByDayArrayInputs.map((item, idx) => (
      <Col key={item.day_id} md="4">
        <div className="m-1">
          <Label className="font-weight-semibold">{capitalizeWord(item.name.slice(0, 3))}</Label>
          <NumberFormat
            thousandSeparator
            prefix="$"
            className="form-control"
            type="text"
            name={`budget_by_day[${item.day_id}]`}
            onChange={(e) => handleBudgetByDayArrayInputs(item.day_id, e)}
            value={item.value}
            decimalScale={2}
            fixedDecimalScale
            autoComplete="off"
            placeholder="$"
            onClick={addDollarSignIfEmpty}
            onBlur={addDollarSignIfEmpty}
            onFocus={addDollarSignIfEmpty}
            onSelect={handleTextSelection}
            onKeyDown={handleKeyDown}
            autoFocus={idx === 0 ? true : false}
          />
        </div>
      </Col>
    ));
      break;
    case 'Volume by Day':
      DailyLimits_HTML = budgetByDayArrayInputs.map((item, _idx) => (
        <Col key={item.day_id} md="4">
          <div className="m-1">
            <Label className="font-weight-semibold">{capitalizeWord(item.name.slice(0, 3))}</Label>
            <NumberFormat
              suffix=" units"
              className="form-control"
              type="text"
              name={`budget_by_day[${item.day_id}]`}
              onChange={(e) => handleBudgetByDayArrayInputs(item.day_id, e)}
              value={item.value}
              decimalScale={0}
              onSelect={handleTextSelection}
              thousandSeparator
              autoComplete="off"
              autoFocus={true}
            />
          </div>
        </Col>
      ));
      break;
    case 'Daily Volume':
      DailyLimits_HTML = (
        <Col>
          <div className="m-1">
            <Label className="font-weight-semibold mb-1 mt-3">
              Daily Volume
            </Label>
            <NumberFormat
              thousandSeparator
              suffix=" units"
              className={`form-control ${visibleAlert && !budgetAndLimitInputs.daily_budget_units ? 'is-invalid' : ''}`}
              type="text"
              name="daily_budget_units"
              onChange={handleBudgetAndLimit}
              value={budgetAndLimitInputs.daily_budget_units}
              isAllowed={(values) => maxBudgetAndUnitsLimit(values, MAX_BUDGETS.DAILY_VOLUME)}
              decimalScale={0}
              autoComplete="off"
              onSelect={handleTextSelection}
              autoFocus={true}
            />
            {(IsAccountRetailAndProductTypeIsLeadsOrCalls(current_account, isProductType) && (selectDailyLimits?.value !== "Unlimited") && (budgetAndLimitInputs.daily_budget_units < 5) && !manageBudgetsAdminPermission(bsh_isAdminUserDetailsPresent, adminPermissionPresent)) ? (
              <small className="text-black ms-2">Minimum 5 units per day</small>
            ) : null
            }
          </div>
        </Col>
      );
      break;
    case 'Daily Budget':
      DailyLimits_HTML = (
        <Col>
          <div className="m-1">
            <Label className="font-weight-semibold mb-1 mt-3">Daily Budget</Label>
            <NumberFormat
              thousandSeparator
              prefix="$"
              className={`form-control ${visibleAlert && !budgetAndLimitInputs.daily_budget_units ? 'is-invalid' : ''}`}
              type="text"
              name="daily_budget_units"
              isAllowed={(values) => maxBudgetAndUnitsLimit(values, MAX_BUDGETS.DAILY_DOLLAR)}
              onChange={handleBudgetAndLimit}
              value={budgetAndLimitInputs.daily_budget_units}
              decimalScale={2}
              fixedDecimalScale
              autoComplete="off"
              autoFocus={true}
              placeholder="$"
              onClick={addDollarSignIfEmpty}
              onBlur={addDollarSignIfEmpty}
              onFocus={addDollarSignIfEmpty}
              onSelect={handleTextSelection}
              onKeyDown={handleKeyDown}
            />
          </div>
        </Col>
      );
      break;
    case 'Unlimited':
      DailyLimits_HTML = '';
      break;
    default: DailyLimits_HTML = '';
      break;
  }

  var monthlyLimits_HTML = '';

  if (selecteMonth.value === 'Monthly Budget') {
    var monthlyLimits_HTML = (
      <FormGroup className=" mb-0">
        <Label className="font-weight-semibold mb-1 mt-3">Monthly Budget</Label>
        <NumberFormat
          thousandSeparator
          prefix="$"
          className={`form-control ${visibleAlert && !budgetAndLimitInputs.monthly_budget_units ? 'is-invalid' : ''}`}
          type="text"
          name="monthly_budget_units"
          isAllowed={(values) => maxBudgetAndUnitsLimit(values, MAX_BUDGETS.MONTHLY_DOLLAR)}
          onChange={handleBudgetAndLimit}
          value={budgetAndLimitInputs.monthly_budget_units}
          decimalScale={2}
          fixedDecimalScale
          autoComplete="off"
          placeholder="$"
          onClick={addDollarSignIfEmpty}
          onBlur={addDollarSignIfEmpty}
          onFocus={addDollarSignIfEmpty}
          onKeyDown={handleKeyDown}
          onSelect={handleTextSelection}
          autoFocus={true}
        />
        <div className="invalid-feedback">
          Please complete the empty fields.
        </div>
      </FormGroup>
    );
  } else if (selecteMonth.value === 'Monthly Volume') {
    var monthlyLimits_HTML = (
      <FormGroup className=" mb-0">
        <Label className="font-weight-semibold mb-1 mt-3">Monthly Volume</Label>
        <NumberFormat
          thousandSeparator
          suffix=" units"
          className={`form-control ${visibleAlert && !budgetAndLimitInputs.monthly_budget_units ? 'is-invalid' : ''}`}
          type="text"
          name="monthly_budget_units"
          onChange={handleBudgetAndLimit}
          isAllowed={(values) => maxBudgetAndUnitsLimit(values, MAX_BUDGETS.MONTHLY_VOLUME)}
          value={budgetAndLimitInputs.monthly_budget_units}
          decimalScale={0}
          onSelect={handleTextSelection}
          autoComplete="off"
          autoFocus={true}
        />

        <div className="invalid-feedback">
          Please complete the empty fields.
        </div>
      </FormGroup>
    );
  } else {
    var monthlyLimits_HTML = '';
  }

  const rowEvents = {
    onMouseEnter: (_e, _column, rowIndex) => {
      setEditIconRow(rowIndex);
    },
    onMouseLeave: (_e, _column, _rowIndex) => {
      setEditIconRow(null);
    },
  };

  // For reseting Loading state
  useEffect(() => {
    if (!modify_campaign_loading) {
      setLoadingCell({ row: null, col: null });
    }
  }, [modify_campaign_loading]);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const decodedFilters = searchParams.get('filters');
    if (decodedFilters) {
      const parsedFilters = JSON.parse(decodeURIComponent(decodedFilters));
      setUrlFilters(parsedFilters);
    }
    bsh_isAdminUserDetailsPresent() && dispatch(getCampaignNotes(current_account?.id))
  }, []);

  const getNewUrl = useUrlFilter();

  useEffect(() => {
    const newURL = getNewUrl(urlFilters, REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_URL_FILTERS_ON_CAMPAIGNS);
    if (newURL !== '') {
      history.push(newURL);
    }
  }, [urlFilters]);

  useEffect(() => {
    urlFilters.forEach(param => {
      const { name, value } = param;
      const decodedKey = decodeURIComponent(name);
      const decodedValue = typeof value === 'object' ? value : decodeURIComponent(value);

      switch (decodedKey) {
        case CAMPAIGN_FILTERS.STATUS:
          const statusValue = decodedValue.charAt(0).toUpperCase() + decodedValue.slice(1);
          setSelectedStatusGroup(getSelectBox(optionGroupStatus[0].options, statusValue));
          bsh_setFilters(STORAGE_KEY.FILTERS.CAMPAIGN, CAMPAIGN_FILTERS.STATUS, getSelectBox(optionGroupStatus[0].options, statusValue));
          break;
        case CAMPAIGN_FILTERS.PRODUCT: {
          // Prefer options derived from actual campaigns (Goal brand may only expose Quote Funnels);
          // fall back to the static list so legacy brands keep working.
          const productOptionFromCampaigns = getSelectBox(optionsCampaignProducts, decodedValue);
          const fallbackProductOption = getSelectBox(optionGroupProduct[0].options, decodedValue);
          const productOption = productOptionFromCampaigns || fallbackProductOption || optionsCampaignProducts[0] || optionGroupProduct[0].options[0];
          setSelectedProductGroup(productOption);
          bsh_setFilters(STORAGE_KEY.FILTERS.CAMPAIGN, CAMPAIGN_FILTERS.PRODUCT, productOption);
          break;
        }
        case CAMPAIGN_FILTERS.LEAD_TYPE:
          setSelectedLeadGroup(getSelectBox(optionLeadTypesState[0].options, decodedValue));
          bsh_setFilters(STORAGE_KEY.FILTERS.CAMPAIGN, CAMPAIGN_FILTERS.LEAD_TYPE, getSelectBox(optionLeadTypesState[0].options, decodedValue));
          break;
        case CAMPAIGN_FILTERS.BRANDS:
          if (decodedValue?.value === OPTION_ALL?.value) {
            setSelectedBrands(brandsOptions)
            bsh_setFilters(STORAGE_KEY.FILTERS.CAMPAIGN, CAMPAIGN_FILTERS.BRANDS, brandsOptions);
          }
          else {
            setSelectedBrands(decodedValue);
            bsh_setFilters(STORAGE_KEY.FILTERS.CAMPAIGN, CAMPAIGN_FILTERS.BRANDS, decodedValue);
          }
          break;
        case CAMPAIGN_FILTERS.DATE_RANGE:
          if (decodedValue?.startDate && decodedValue?.endDate) {
            const startDate = new Date(decodedValue?.startDate);
            const endDate = new Date(decodedValue?.endDate);
            const nextRange = {
              label: createLabelWithDateRange({ label: DATE_RANGE_OPTIONS_DISPLAY.CUSTOM_RANGE, startDate, endDate }),
              value: {
                startDate,
                endDate
              },
              original_label: DATE_RANGE_OPTIONS.CUSTOM_RANGE,
              timezone: getIANATimezoneStringForAbbreviation(current_account?.timezone)
            };
            if (!areDateRangesEqual(selectedDateRange, nextRange)) {
              setSelectedDateRange(nextRange);
            }
            bsh_setFilters(STORAGE_KEY.FILTERS.CAMPAIGN, CAMPAIGN_FILTERS.DATE_RANGE, {
              label: nextRange.label,
              value: {
                startDate: startDate?.toISOString(),
                endDate: endDate?.toISOString()
              },
              original_label: DATE_RANGE_OPTIONS.CUSTOM_RANGE,
              timezone: nextRange.timezone
            });
          }
          else {
            if (selectedDateRange?.original_label !== decodedValue) {
              const presetRange = createOption(
                decodedValue,
                new Date(),
                getIANATimezoneStringForAbbreviation(current_account?.timezone)
              );
              setSelectedDateRange(presetRange);
              bsh_setFilters(STORAGE_KEY.FILTERS.CAMPAIGN, CAMPAIGN_FILTERS.DATE_RANGE, presetRange);
            }
          }
          break;
        default:
          break;
      }
    });
  }, [urlFilters, brandsOptions, optionsCampaignProducts]);

  const updateUrlFilters = (name, value) => {
    const filterIndex = urlFilters.findIndex(filter => filter.name === name);
    if (filterIndex !== -1) {
      const updatedFilters = [...urlFilters];
      updatedFilters[filterIndex].value = value;
      setUrlFilters(updatedFilters);
    } else {
      setUrlFilters([...urlFilters, { name, value }]);
    }
  };

  const isPingPostCampaign = useCallback((campaign_id) => {
    if (filteredCampaignsList.length) {
      const campaign = filteredCampaignsList.find(each_campaign => each_campaign.id === campaign_id)
      if (campaign) {
        // V2: backend pre-computes is_ping_post and drops the lead_integrations embed.
        if (typeof campaign.is_ping_post === 'boolean')
          return campaign.is_ping_post;

        // V1 fallback: derive from the embedded lead_integrations phase when the flag is off.
        const lead_integrations = campaign.lead_integrations
        if (lead_integrations?.length) {
          const ping_phase_integrations = lead_integrations.filter((integration) => integration.phase === 'ping')
          const post_phase_integrations = lead_integrations.filter((integration) => integration.phase === 'post')
          return ping_phase_integrations.length > 0 && post_phase_integrations.length > 0
        }
      }
    }
    return false
  }, [filteredCampaignsList])
  const nameColumnHeaderFormatter = (column, colIndex, { sortElement, filterElement }, tooltipName, columnTitle, tooltipdescription, sortOrderForName) => {
    return (
      <div className='d-flex align-items-end' style={column?.sort ? { cursor: 'pointer' } : {}}>
        <span className="me-1 text-center">{columnTitle}</span>
        <div className={`d-flex align-items-center header-cell-parent ${sortOrderForName === ORDER_BY.DESC && ''}`}>
          <div>
            {sortElement}
          </div>
          <i id={`tooltip-${tooltipName}-${colIndex}`} className='ms-1 bx bx-info-circle text-black bx-xs'></i>
          <UncontrolledTooltip placement="top" target={`tooltip-${tooltipName}-${colIndex}`}>
            {tooltipdescription}
          </UncontrolledTooltip>
          {filterElement}
        </div>
      </div>
    );
  }

  const statusColumn = {
    dataField: 'active',
    footer: '',
    text: 'Status',
    hasInfoTooltip: true,
    tooltipDescription: 'Turn campaign on or off',
    headerFormatter: forColumnHeaderWrapper,
    search: true,
    events: {

      onClick: (_e, _column, _columnIndex, row, rowIndex) => {
        setLoadingCell({ row: rowIndex, col: CAMPAIGN_TABLE_COLMN_NAME.ACTION });
        {
          setIsEditingMonthlyBudget(null);
          setIsEditingDailyBudget(null);
          setIsEditingName(null);
        }
      },
    },
    sticky: true,
    formatExtraData: { canManageCampaign: canManageCampaign },
    formatter: (_cellContent, row, rowIndex, extra_data) => {
      const canManageCurrentCampaign = extra_data.canManageCampaign(row?.id);
      const isCampaignDiscarded = !!row.discarded_at;
      const campaignStyles = getCampaignStyles(isCampaignDiscarded);
      
      return (
        <div className="d-flex gap-3 justify-content-start">
          <UncontrolledDropdown disabled={!canManageCurrentCampaign || row?.product_type_id === PRODUCT_TYPE_IDS.SYNDI_CLICKS || isCampaignDiscarded}>
            <DropdownToggle className="card-drop" tag="i" {...campaignStyles.toggle}>
              {
                (modify_campaign_loading === true)
                  && (loadingCell.row === rowIndex)
                  && (loadingCell.col === CAMPAIGN_TABLE_COLMN_NAME.ACTION) ? (<ModifyLoadingIcon color="secondary" />) : (
                  <>
                    <i className={`mdi mdi-circle font-size-16 ${row.active ? 'sfgreen' : 'sfred'}`} />
                    {canManageCurrentCampaign && row?.product_type_id !== PRODUCT_TYPE_IDS.SYNDI_CLICKS && !isCampaignDiscarded && (
                      <span className={`font-size-16 ${canManageCurrentCampaign && (rowIndex === editIconRow) ? '' : 'edit-hover-class'}`}>
                        <a><i className="mdi mdi-chevron-down" /></a>
                      </span>)}
                  </>
                )
              }

            </DropdownToggle>
            {!isCampaignDiscarded && (
              <DropdownMenu className="dropdown-menu-start">
                <DropdownItem onClick={() => onUpdateStatus(row, true)}>
                  <div className="d-inline-flex align-content-center">
                    <i className='mdi mdi-circle font-size-16 sfgreen' />
                    <div className="ms-2 d-flex align-self-center">Active</div>
                  </div>
                </DropdownItem>
                <DropdownItem onClick={() => onUpdateStatus(row, false)}>
                  <div className="d-inline-flex align-content-center">
                    <i className='mdi mdi-circle font-size-16 sfred' />
                    <div className="ms-2 d-flex align-self-center">Paused</div>
                  </div>
                </DropdownItem>
              </DropdownMenu>
            )}
          </UncontrolledDropdown>
        </div>
      )
    },
    filter: textFilter({
      // not displaying the text input field since that is controlled by react-select
      style: {
        display: 'none',
      },
      getFilter: (filter) => {
        statusFilter = filter;
      },
    }),
    filterValue: (_cell, row) => (
      row.active ? 'active' : 'paused'
    ),
    csvFormatter: (_cellContent, row, rowIndex) => (_cellContent ? "Active" : "Inactive")
  };

  const nameColumn = {
    dataField: 'name',
    footer: '',
    footerFormatter: ((_column, data) => "Total"),
    text: 'Name',
    hasInfoTooltip: true,
    tooltipDescription: 'Name of the campaign',
    headerFormatter: forColumnHeaderWrapper,
    sticky: true,
    sort: true,
    filter: textFilter({
      // not displaying the text input field since that is controlled by react-select
      style: {
        display: 'none',
      },
      getFilter: (filter) => {
        nameFilter = filter;
      },
    }),
    events: {
      onClick: (e, _column, _columnIndex, row, rowIndex) => {
        if (e.target.name === 'saveName') {
          if (onClickNameHandle(row, nameInput)) {
            setIsEditingName(null);
            setNameInput('');
          }
        } else if (e.target.name === 'resetName') {
          setIsEditingName(null);
        } else if (e.target.id === 'pencil-icon-name') {
          setLoadingCell({ row: rowIndex, col: CAMPAIGN_TABLE_COLMN_NAME.NAME });
          setIsEditingName({ row: rowIndex });
          setIsEditingMonthlyBudget(null);
          setIsEditingDailyBudget(null);
          setNameInput(row.name);
        }
      },
      onKeyDown: (e, row, rowIndex) => {
        if ([KEY_NAMES.ENTER, KEY_NAMES.NUMERIC_PAD_ENTER].includes(e.code)) {
          if (onClickNameHandle(row, nameInput)) {
            setIsEditingName(null);
            setNameInput('');
          }
        }
      },
    },
    formatExtraData: { canManageCampaign: canManageCampaign },
    formatter: (_cellContent, row, rowIndex, extra_data) => {
      const canManageCurrentCampaign = extra_data.canManageCampaign(row?.id);
      const isCampaignDiscarded = !!row.discarded_at;
      const campaignStyles = getCampaignStyles(isCampaignDiscarded);
      
      return (
        <div style={enable_sticky_columns ? { minHeight: "30px" } : {}} className="d-flex align-items-center">
          <UncontrolledDropdown
            ref={isTextSelected ? '' : dropdownMenuRefCampaignName}
            isOpen={((isEditingName != null) && canManageCurrentCampaign && !isCampaignDiscarded && (isEditingName.row == rowIndex))}>
            <DropdownToggle
              href="#"
              className='card-drop fsnormal'
              tag="i"
            >
              {
                (modify_campaign_loading === true)
                  && (loadingCell.row === rowIndex)
                  && (loadingCell.col === CAMPAIGN_TABLE_COLMN_NAME.NAME) ? (<ModifyLoadingIcon color="secondary" />) : (
                  <div className="d-flex align-items-center">
                    <Link to={`/campaigns/${row.id}/summary`} {...campaignStyles.link}>
                      <div className={`fw-medium text-truncate ${campaignStyles.textClass || 'text-sfblue'}`} style={{ maxWidth: "250px" }}>
                        {isCampaignDiscarded ? `${row.name} (deleted)` : row.name}
                      </div>
                    </Link>
                  </div>
                )
              }
            </DropdownToggle>
            {!isCampaignDiscarded && (
              <DropdownMenu className="dropdown-menu-start">
                <DropdownItem className="font-weight-semibold">Campaign Name</DropdownItem>
                <DropdownItem divider />
                <DropdownItem text>
                  <div className="d-flex flex-column">
                    <div>
                      <Input
                        className="form-control sf-box-w"
                        type="text"
                        maxLength={35}
                        value={nameInput}
                        autoFocus={true}
                        onChange={(e) => {
                          e.persist();
                          setNameInput(e.target.value);
                          handleTextSelection(e);
                        }}
                        onSelect={handleTextSelection}
                      />
                    </div>
                    <div className="ms-auto mt-2">
                      <button className={`btn btn-sm ${getPrimaryButtonClass()} mx-1`} name="saveName" type="submit">Save</button>
                      <button className="btn btn-sm btn-light mx-1" name="resetName" type="reset">Cancel</button>
                    </div>
                  </div>
                </DropdownItem>
              </DropdownMenu>
            )}
          </UncontrolledDropdown>
          {
            (canManageCurrentCampaign && row?.product_type?.name !== NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS && !isCampaignDiscarded) && (
              <span className={`ms-1 font-size-16 ${(canManageCurrentCampaign) && (rowIndex === editIconRow) ? '' : 'edit-hover-class'}`}>
                <a><i id="pencil-icon-name" className="mdi mdi-pencil text-success" /></a>
              </span>)
          }
          {isPingPostCampaign(row.id) && <div className='ms-1'>
            <div className="fw-medium text-sfblue">
              <i id={`tooltip-campaign-integration-${row.id}`} className="bx bx-xs bx-shape-circle text-sfblue" />
              <UncontrolledTooltip placement="top" target={`tooltip-campaign-integration-${row.id}`}>
                Ping-post campaign.
              </UncontrolledTooltip>
            </div>
          </div>}
        </div>
      )
    },
    csvFormatter: (_cellContent, row, rowIndex) => (row?.name ? (row.discarded_at ? `${row.name} (deleted)` : row.name) : "")
  };
  const brandColumn = {
    dataField: 'brand[name]',
    footer: '',
    text: 'Brand',
    hasDynamicFields: true,
    dynamicTooltipID: 'brand_name',
    tooltipDescription: 'Name of the Brand',
    headerFormatter: forColumnHeaderWrapper,
    sticky: true,
    sort: true,
    formatter: Formatters.defaultFormatter,
    csvFormatter: (cellContent, _row, _rowIndex) => (cellContent ? cellContent : "")
  };
  const optionColumn = {
    dataField: 'options',
    footer: '',
    text: 'Options',
    csvExport: false,
    events: {
      onClick: (_e, _column, _columnIndex, _row, rowIndex) => {
        {
          setIsEditingMonthlyBudget(null);
          setIsEditingDailyBudget(null);
          setIsEditingName(null);
        }
      },
    },
    formatExtraData: { canManageCampaign: canManageCampaign },
    formatter: (_cellContent, row, _ri, extra_data) => {
      const canManageCurrentCampaign = extra_data.canManageCampaign(row?.id);
      const isCampaignDiscarded = !!row.discarded_at;
      const campaignStyles = getCampaignStyles(isCampaignDiscarded);
      
      return (
        <div style={enable_sticky_columns ? { minHeight: "30px" } : {}} className="d-flex gap-3 align-items-center">
          <UncontrolledDropdown
            style={{ position: "absolute" }}
            disabled={isCampaignDiscarded}
          >
            <DropdownToggle
              href="#"
              className="card-drop"
              tag="i"
              {...campaignStyles.toggle}
            >
              <i className="mdi mdi-dots-horizontal font-size-18" />
            </DropdownToggle>
            {!isCampaignDiscarded && (
              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem className="font-weight-semibold">Options</DropdownItem>
                <DropdownItem divider />
                <Link to={`/campaigns/${row.id}/summary`}>
                  <DropdownItem>
                    Campaign Summary
                  </DropdownItem>
                </Link>
                {(canManageCurrentCampaign) && (

                  <Link to={`/campaigns/${row.id}/edit`}>
                    <DropdownItem>
                      Edit Campaign
                    </DropdownItem>
                  </Link>
                )}
              {(row?.product_type?.name === NAME_OF_PRODUCT_TYPES.CLICKS || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS) ? (<>
                <Link to={`/campaigns/${row.id}/adgroups`}>
                  <DropdownItem>
                    Ad Groups
                  </DropdownItem>
                </Link>
                {row?.product_type?.name === NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS ? (bsh_isAdminUserDetailsPresent() || current_account?.source_settings_enabled) && <Link to={`/campaigns/${row.id}/source-setting`}>
                  <DropdownItem>
                    Source Settings
                  </DropdownItem>
                </Link> :
                  <Link to={`/campaigns/${row.id}/source-setting`}>
                    <DropdownItem>
                      Source Settings
                    </DropdownItem>
                  </Link>
                }
              </>) : (<>
                {
                  isProfilesEnabled && (
                    <Link to={`/campaigns/${row.id}/profiles`}>
                      <DropdownItem>
                        Profiles
                      </DropdownItem>
                    </Link>
                  )
                }
                {(isSourceSettingsEnabled && sourceSettingEnabledFromAccountSetting) || (isSourceSettingsEnabled && isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_SOURCE_SETTINGS_FOR_LEADS_AND_CALLS) && bsh_isAdminUserDetailsPresent()) ? (
                  <Link to={`/campaigns/${row.id}/call-lead-source-setting`}>
                    <DropdownItem>
                      Source Settings
                      {!sourceSettingEnabledFromAccountSetting && <AdminOnlyIcon idFor="source_settings" tooltipText={ADMIN_ONLY_TAB} />}
                    </DropdownItem>
                  </Link>
                ) : null}

              </>)
              }

              {
                (canManageCurrentCampaign) && (
                  <>
                    <DropdownItem>
                      <div onClick={() => onClickDuplicateCampaign(row)}>
                        Duplicate Campaign
                      </div>
                    </DropdownItem>
                    {row?.product_type?.name !== NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS && (
                      <DropdownItem>
                        <div onClick={() => onClickDelete(row)}>
                          Delete Campaign
                        </div>
                      </DropdownItem>
                    )}
                  </>
                )
              }
              {isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.ADMIN_SPECIFIC_SETTINGS_CAMPAIGN) && (row?.product_type?.name !== NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS) &&
                bsh_isAdminUserDetailsPresent() && ((row?.product_type?.name === NAME_OF_PRODUCT_TYPES.CLICKS || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS) ? <>
                  <Link to={`/campaigns/${row?.id}/campaign-analysis`}>
                    <DropdownItem>
                      Analyze Campaign
                      <AdminOnlyIcon idFor="analyze_campaign" tooltipText={ADMIN_ONLY_TAB} />
                    </DropdownItem>
                  </Link>
                </>
                  :
                  <>
                    <Link to={`/campaigns/${row?.id}/leads-calls-campaign-analysis`}>
                      <DropdownItem>
                        Analyze Campaign
                        <AdminOnlyIcon idFor="analyze_campaign" tooltipText={ADMIN_ONLY_TAB} />
                      </DropdownItem>
                    </Link>
                  </>
                )
              }
              </DropdownMenu>
            )}
          </UncontrolledDropdown>
        </div>
      )
    },
  };

  const _hide_col = _.cloneDeep(user_column_preference_campaign)
  for (const key in user_column_preference_campaign) {
    _hide_col[key] = user_column_preference_campaign == null ? false : user_column_preference_campaign[key]
  }

  const hide_col = useMemo(() => {
    const updated_hide_col = { ..._hide_col }

    if (current_account) {
      if (!(isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_USER_COLUMN_PREFERENCE))) {
        updated_hide_col['product_type'] = false;
        updated_hide_col['lead_type'] = false;
        updated_hide_col['daily_budget'] = false;
        updated_hide_col['monthly_budget'] = false;
        updated_hide_col['click_analytic_searches'] = false;
        updated_hide_col['click_analytic_impressions'] = false;
        updated_hide_col['click_analytic_queries'] = false;
        updated_hide_col['click_analytic_clicks'] = false;
        updated_hide_col['click_analytic_total_payout'] = false;
        updated_hide_col['click_analytic_cpc'] = false;
        updated_hide_col['contribution_margin'] = false;
        updated_hide_col['profit'] = false;
        updated_hide_col['is_lead_product'] = false
        updated_hide_col['is_lead_type'] = false
        updated_hide_col['is_lead_daily_limit'] = false
        updated_hide_col['is_lead_monthly_limit'] = false
        updated_hide_col['is_lead_inventory'] = false
        updated_hide_col['is_lead_opportunities'] = false
        updated_hide_col['is_lead_target_rate'] = false
        updated_hide_col['is_lead_bids'] = false
        updated_hide_col['is_lead_bid_rate'] = false
        updated_hide_col['is_lead_posts'] = false
        updated_hide_col['is_lead_accepted'] = false
        updated_hide_col['is_lead_accept_rate'] = false
        updated_hide_col['is_lead_avg_bid'] = false
        updated_hide_col['is_lead_avg_cpl'] = false
        updated_hide_col['is_lead_spend'] = false
        updated_hide_col['is_call_product'] = false
        updated_hide_col['is_call_type'] = false
        updated_hide_col['is_call_daily_limit'] = false
        updated_hide_col['is_call_monthly_limit'] = false
        updated_hide_col['is_call_inventory'] = false
        updated_hide_col['is_call_opportunities'] = false
        updated_hide_col['is_call_target_rate'] = false
        updated_hide_col['is_call_bids'] = false
        updated_hide_col['is_call_bid_rate'] = false
        updated_hide_col['is_call_transfers'] = false
        updated_hide_col['is_call_accepted'] = false
        updated_hide_col['is_call_accept_rate'] = false
        updated_hide_col['is_call_avg_bid'] = false
        updated_hide_col['is_call_avg_cpc'] = false
        updated_hide_col['is_call_spend'] = false
        updated_hide_col['is_call_avg_duration'] = false
        updated_hide_col['is_lead_profit'] = false
        updated_hide_col['is_lead_cm'] = false
        updated_hide_col['is_call_profit'] = false
        updated_hide_col['is_call_cm'] = false
        updated_hide_col['is_click_inventory'] = false
        updated_hide_col['is_click_opportunities'] = false
        updated_hide_col['is_click_target_rate'] = false
        updated_hide_col['is_click_bids'] = false
        updated_hide_col['is_click_bid_rate'] = false
        updated_hide_col['is_click_impressions'] = false
        updated_hide_col['is_click_total_clicks'] = false
        updated_hide_col['is_click_total_leads'] = false
        updated_hide_col['is_click_total_calls'] = false
        updated_hide_col['is_click_success_rate'] = false
        updated_hide_col['is_click_avg_bid'] = false
        updated_hide_col['is_click_avg_cpc'] = false
        updated_hide_col['is_click_total_cost'] = false
        updated_hide_col['is_click_profit'] = false
        updated_hide_col['is_click_cm'] = false
        updated_hide_col['is_click_product'] = false
        updated_hide_col['is_click_type'] = false
        updated_hide_col['is_click_daily_limit'] = false
        updated_hide_col['is_click_monthly_limit'] = false
        updated_hide_col['is_generic_units'] = false
        updated_hide_col['is_generic_avg_bid'] = false
        updated_hide_col['is_generic_cpx'] = false
        updated_hide_col['is_generic_spend'] = false
        updated_hide_col['is_prefill_success_rate'] = false;
        updated_hide_col['is_win_rate'] = false;
      }
      if (!current_account?.internal) {
        updated_hide_col['contribution_margin'] = null;
        updated_hide_col['profit'] = null;
        updated_hide_col['is_lead_profit'] = null;
        updated_hide_col['is_lead_cm'] = null;
        updated_hide_col['is_call_profit'] = null;
        updated_hide_col['is_call_cm'] = null;
        updated_hide_col['is_click_profit'] = null;
        updated_hide_col['is_click_cm'] = null;
      }

      if (!(bsh_isAdminUserDetailsPresent())) {
        updated_hide_col['click_analytic_impressions'] = null;
        updated_hide_col['click_analytic_queries'] = null;
        updated_hide_col['is_click_inventory'] = null;
        updated_hide_col['is_click_opportunities'] = null;
        updated_hide_col['is_click_target_rate'] = null;
        updated_hide_col['is_click_bids'] = null;
        updated_hide_col['is_click_bid_rate'] = null;
        updated_hide_col['is_lead_inventory'] = null;
        updated_hide_col['is_lead_opportunities'] = null;
        updated_hide_col['is_lead_target_rate'] = null;
        updated_hide_col['is_lead_bids'] = null;
        updated_hide_col['is_lead_bid_rate'] = null;
        updated_hide_col['is_call_inventory'] = null;
        updated_hide_col['is_call_opportunities'] = null;
        updated_hide_col['is_call_target_rate'] = null;
        updated_hide_col['is_call_bids'] = null;
        updated_hide_col['is_call_bid_rate'] = null;
        updated_hide_col['click_analytic_total_payout'] = null;
        updated_hide_col['click_analytic_cpc'] = null;
        updated_hide_col['is_call_avg_duration'] = null;
        updated_hide_col['is_campaign_pace'] = null;
        updated_hide_col['is_campaign_notes'] = null;
      }

      if (!isMetricsEnabled) {
        updated_hide_col['is_lead_opportunities'] = null;
        updated_hide_col['is_lead_bids'] = null;

        updated_hide_col['is_call_opportunities'] = null;
        updated_hide_col['is_call_bids'] = null;

        updated_hide_col['contribution_margin'] = null;
        updated_hide_col['profit'] = null;
        updated_hide_col['is_lead_profit'] = null;
        updated_hide_col['is_lead_cm'] = null;
        updated_hide_col['is_call_profit'] = null;
        updated_hide_col['is_call_cm'] = null;
        updated_hide_col['is_click_profit'] = null;
        updated_hide_col['is_click_cm'] = null;
      }

      if (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_CONVERSION_AND_REVENUE_METRICS) 
          || !current_account?.internal) {
        updated_hide_col['is_total_conversions'] = null;
        updated_hide_col['is_total_revenue'] = null;
      }

      if (!roas_column_show_ff && updated_hide_col) {
        updated_hide_col[PIXEL_COLUMN_TABLE_FIELDS.DISP_ROAS] = null;
        updated_hide_col[PIXEL_COLUMN_TABLE_FIELDS.DISP_CLICKS_ROAS] = null;
        updated_hide_col[PIXEL_COLUMN_TABLE_FIELDS.DISP_LEADS_ROAS] = null;
        updated_hide_col[PIXEL_COLUMN_TABLE_FIELDS.DISP_CALLS_ROAS] = null;
      }
      updated_hide_col['is_call_wait_time'] = null;
    }
    return updated_hide_col;

  }, [user_column_preference_campaign, _hide_col, current_account]);

  // this function to determine loading state by product type
  const getStatsLoading = (productType) => {
    switch (productType) {
      case NAME_OF_PRODUCT_TYPES.LEADS:
        return leads_stats_loading;
      case NAME_OF_PRODUCT_TYPES.CALLS:
        return loading_all_cmps_call_stats;
      case NAME_OF_PRODUCT_TYPES.CLICKS:
        return click_campaign_stats_loading;
      default:
        return loading_all_cmps_stats;
    }
  };

  const loading_stats = useMemo(() => {
    return getStatsLoading(selectedProductGroup?.value)
  }, [loading_all_cmps_stats, leads_stats_loading, loading_all_cmps_call_stats, click_campaign_stats_loading])

  const commonColumnsForAllTypes = [
    {
      dataField: 'product_type[name]',
      footer: '',
      hidden: new_campaign_page_feature_flag_active ? (selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CLICKS ? hide_col?.['is_click_product'] :
        selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.LEADS ? hide_col?.['is_lead_product'] :
          selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CALLS ? hide_col?.['is_call_product'] : hide_col?.['product_type']) : hide_col?.['product_type'],
      csvExport: !(new_campaign_page_feature_flag_active ? (selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CLICKS ? hide_col?.['is_click_product'] :
        selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.LEADS ? hide_col?.['is_lead_product'] :
          selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CALLS ? hide_col?.['is_call_product'] : hide_col?.['product_type']) : hide_col?.['product_type']),
      text: 'Product',
      hasDynamicFields: true,
      dynamicTooltipID: 'product',
      tooltipDescription: 'Type of product',
      headerFormatter: forColumnHeaderWrapper,
      filter: textFilter({
        // not displaying the text input field since that is controlled by react-select
        style: {
          display: 'none',
        },
        getFilter: (filter) => {
          productTypeFilter = filter;
        },
      }),
      sort: false,
      formatter: (cell, _row) => (
        <div>{getCampaignProductLabel(cell, goal_marketplace_flag_active)}</div>
      ),
      csvFormatter: (cellContent, row, rowIndex) => getCampaignProductLabel(cellContent, goal_marketplace_flag_active),
      columnName: new_campaign_page_feature_flag_active ? (selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CLICKS ? 'is_click_product' :
        selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.LEADS ? 'is_lead_product' :
          selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CALLS ? 'is_call_product' : 'product_type') : 'product_type',
    },
    {
      dataField: 'lead_type[name]',
      footer: '',
      hidden: new_campaign_page_feature_flag_active ? (selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CLICKS ? hide_col?.['is_click_type'] :
        selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.LEADS ? hide_col?.['is_lead_type'] :
          selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CALLS ? hide_col?.['is_call_type'] : hide_col?.['lead_type']) : hide_col?.['lead_type'],
      csvExport: !(new_campaign_page_feature_flag_active ? (selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CLICKS ? hide_col?.['is_click_type'] :
        selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.LEADS ? hide_col?.['is_lead_type'] :
          selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CALLS ? hide_col?.['is_call_type'] : hide_col?.['lead_type']) : hide_col?.['lead_type']),
      text: 'Type',
      hasDynamicFields: true,
      dynamicTooltipID: 'lead-type',
      tooltipDescription: 'Type of insurance',
      headerFormatter: forColumnHeaderWrapper,
      filter: textFilter({
        // not displaying the text input field since that is controlled by react-select
        style: {
          display: 'none',
        },
        getFilter: (filter) => {
          leadTypeFilter = filter;
        },
      }),
      formatter: (cell, _row) => (
        <div>{cell.charAt(0).toUpperCase() + cell.slice(1)}</div>
      ),
      sort: false,
      csvFormatter: (_cellContent, row, rowIndex) => (_cellContent ? _cellContent.charAt(0).toUpperCase() + _cellContent.slice(1) : ""),
      columnName: new_campaign_page_feature_flag_active ? (selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CLICKS ? 'is_click_type' :
        selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.LEADS ? 'is_lead_type' :
          selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CALLS ? 'is_call_type' : 'lead_type') : 'lead_type',
    },
    {
      dataField: 'budget[daily_budget_units]',
      footer: '',
      hidden: new_campaign_page_feature_flag_active ? (selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CLICKS ? hide_col?.['is_click_daily_limit'] :
        selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.LEADS ? hide_col?.['is_lead_daily_limit'] :
          selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CALLS ? hide_col?.['is_call_daily_limit'] : hide_col?.['daily_budget']) : hide_col?.['daily_budget'],
      csvExport: !(new_campaign_page_feature_flag_active ? (selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CLICKS ? hide_col?.['is_click_daily_limit'] :
        selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.LEADS ? hide_col?.['is_lead_daily_limit'] :
          selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CALLS ? hide_col?.['is_call_daily_limit'] : hide_col?.['daily_budget']) : hide_col?.['daily_budget']),
      text: 'Daily Limit',
      sort: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_SORT_ICON_AT_DAILY_AND_MONTHLY_LIMIT),
      sortFunc: sortDailyLimit,
      hasDynamicFields: true,
      dynamicTooltipID: 'daily-limit',
      tooltipDescription: 'Total opportunities you can receive in a day',
      headerFormatter: forColumnHeaderWrapper,
      events: {
        onKeyDown: (e, row, rowIndex) => {
          if ([KEY_NAMES.ENTER, KEY_NAMES.NUMERIC_PAD_ENTER].includes(e.code)) {
            onClickSaveDailyBudget(row, nameInput);
          }
        },
        onClick: (e, _column, _columnIndex, row, rowIndex) => {
          setLoadingCell({ row: rowIndex, col: CAMPAIGN_TABLE_COLMN_NAME.DAILY_LIMIT });
          if (e.target.name === 'saveName') {
            onClickSaveDailyBudget(row, nameInput);
          } else if (e.target.name === 'resetName') {
            setIsEditingDailyBudget(null);
          } else// Still editing
          {
            const campaignBudgetUIState = getCampaignBudgetUIState({
              campaign_budgets: row.campaign_budgets,
              monthly_budget: row.monthly_budget,
              monthly_volume: row.monthly_volume,
            });
            if (isEditingDailyBudget?.row != rowIndex) {
              setSelectDailyLimits(getSelectBox(getDailyBudgetTypeOptions(row?.product_type?.name, current_account)[0].options, campaignBudgetUIState?.daily_limit_type));
              if (campaignBudgetUIState?.daily_limit_type == 'Budget by Day') {
                const prevState = DAY_ARRARY.map((item, _idx) => ({ ...item, value: row.campaign_budgets.find((cam) => cam.day_id == item.day_id).dollar_budget }));
                setBudgetByDayArrayInputs(prevState);
              } else if (campaignBudgetUIState?.daily_limit_type == 'Volume by Day') {
                const prevState = DAY_ARRARY.map((item, _idx) => ({ ...item, value: row.campaign_budgets.find((cam) => cam.day_id == item.day_id).volume_budget }));
                setBudgetByDayArrayInputs(prevState);
              } else {
                setBudgetByDayArrayInputs([...DAY_ARRARY]);
              }
              setBudgetAndLimitInputs({ ...budgetAndLimitInputs, daily_budget_units: campaignBudgetUIState?.daily_budget_units });
              setIsProductType(row?.product_type?.name);
            }
            setIsEditingDailyBudget({ row: rowIndex });
            setIsEditingMonthlyBudget(null);
            setIsEditingName(null);
          }
        },
      },
      formatExtraData: { canManageCampaign: canManageCampaign },
      formatter: (_cellContent, row, rowIndex, extra_data) => {
        const canManageCurrentCampaign = extra_data.canManageCampaign(row?.id);
        const hasDailyBudgetOptions = doesAccountHaveDailyBudgetOptions(current_account, row?.product_type?.name);
        const isCampaignDiscarded = !!row.discarded_at;
        const campaignStyles = getCampaignStyles(isCampaignDiscarded);

        return (
          <div className="d-flex">
            <UncontrolledDropdown
              ref={isTextSelected ? '' : dropdownMenuRefCampaignDayLimits}
              isOpen={((isEditingDailyBudget != null) && canManageCurrentCampaign && hasDailyBudgetOptions && !isCampaignDiscarded && (isEditingDailyBudget.row == rowIndex)) && (!isEditingMonthlyBudget)}>
              <DropdownToggle href="#" className='card-drop fsnormal' tag="i" {...campaignStyles.toggle}>
                {
                  (modify_campaign_loading === true)
                    && (loadingCell.row === rowIndex)
                    && (loadingCell.col === CAMPAIGN_TABLE_COLMN_NAME.DAILY_LIMIT) ? (<ModifyLoadingIcon color="secondary" />) : (
                    <>
                      <span className={`${campaignStyles.textClass || 'text-black'}`}>{getDailyBudgetStringForCell(row)}</span>
                      {
                        (canManageCurrentCampaign && hasDailyBudgetOptions && !isCampaignDiscarded) && (
                          <span className={`ms-1 font-size-16 ${(rowIndex === editIconRow) ? '' : 'edit-hover-class'}`}>
                            <a><i className="mdi mdi-pencil text-success" /></a>
                          </span>)
                      }
                    </>
                  )
                }
              </DropdownToggle>
              {!isCampaignDiscarded && (
                <DropdownMenu className="dropdown-menu-start">
                  <DropdownItem className="font-weight-semibold">Daily Limit</DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem text style={{ width: '365px' }}>
                    <div className="d-flex flex-column">
                      <div className="form-group">
                        <Select
                          name="daily_limit_type"
                          onChange={(e) => {
                            handleDailyLimits(e);
                            handleTextSelection(e)
                          }}
                          value={selectDailyLimits}
                          options={getDailyBudgetTypeOptions(row?.product_type?.name, current_account)}
                          classNamePrefix="select2-selection sf_dropdown_popup"
                          placeholder=""
                        />
                      </div>
                      <div className="fom-group">
                        <Row>
                          {DailyLimits_HTML}
                          <Col md={12}>
                            {(visibleAlert) ? <Alert isOpen={visibleAlert} className="bg-transparent border-0 text-danger">Please complete the empty fields.</Alert> : null}
                          </Col>
                        </Row>
                      </div>
                      <div className="ms-auto mt-2">
                        <button className={`btn btn-sm ${getPrimaryButtonClass()} mx-1`} name="saveName"
                          disabled={(IsAccountRetailAndProductTypeIsLeadsOrCalls(current_account, isProductType) && (selectDailyLimits?.value !== "Unlimited") && (budgetAndLimitInputs.daily_budget_units < 5) &&
                            !manageBudgetsAdminPermission(bsh_isAdminUserDetailsPresent, adminPermissionPresent))}
                          type="submit">Save</button>
                        <button className="btn btn-sm btn-light mx-1" name="resetName" type="reset">Cancel</button>
                      </div>
                    </div>
                  </DropdownItem>
                </DropdownMenu>
              )}
            </UncontrolledDropdown>
          </div>
        )
      },
      csvFormatter: (_cellContent, row, rowIndex) => {
        const result = getDailyBudgetStringForCell(row);
        if (typeof result === 'string') {
          return result
        }
        if (result?.props?.suffix) {
          return `${SfCommaStringFormatter(result?.props?.value || 0)}${result?.props?.suffix}`
        }
        return SfDollarStringFormatter(result?.props?.value || 0.00)
      },
      columnName: new_campaign_page_feature_flag_active ? (selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CLICKS ? 'is_click_daily_limit' :
        selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.LEADS ? 'is_lead_daily_limit' :
          selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CALLS ? 'is_call_daily_limit' : 'daily_budget') : 'daily_budget',
    },
    {
      dataField: 'budget.monthly_budget',
      footer: '',
      hidden: new_campaign_page_feature_flag_active ? (selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CLICKS ? hide_col?.['is_click_monthly_limit'] :
        selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.LEADS ? hide_col?.['is_lead_monthly_limit'] :
          selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CALLS ? hide_col?.['is_call_monthly_limit'] : hide_col?.['monthly_budget']) : hide_col?.['monthly_budget'],
      csvExport: !(new_campaign_page_feature_flag_active ? (selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CLICKS ? hide_col?.['is_click_monthly_limit'] :
        selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.LEADS ? hide_col?.['is_lead_monthly_limit'] :
          selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CALLS ? hide_col?.['is_call_monthly_limit'] : hide_col?.['monthly_budget']) : hide_col?.['monthly_budget']),
      columnName: new_campaign_page_feature_flag_active ? (selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CLICKS ? 'monthly_budget' :
        selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.LEADS ? 'is_lead_monthly_limit' :
          selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CALLS ? 'is_call_monthly_limit' : 'monthly_budget') : 'monthly_budget',
      text: 'Monthly Limit',
      hasDynamicFields: true,
      dynamicTooltipID: 'monthly-limit',
      tooltipDescription: 'Total opportunities you can receive in a month',
      headerFormatter: forColumnHeaderWrapper,
      sort: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_SORT_ICON_AT_DAILY_AND_MONTHLY_LIMIT),
      sortFunc: sortMonthlyLimit,
      events: {
        onKeyDown: (e, row, rowIndex) => {
          if (!IsMonthlyBudgetFeatureEnabled(current_account, row?.product_type)) {
            return;
          }
          if ([KEY_NAMES.ENTER, KEY_NAMES.NUMERIC_PAD_ENTER].includes(e.code)) {
            onClickSaveMonthlyBudget(row, nameInput);
          }
        },
        onClick: (e, _column, _columnIndex, row, rowIndex) => {
          if (!IsMonthlyBudgetFeatureEnabled(current_account, row?.product_type)) {
            return;
          }
          setLoadingCell({ row: rowIndex, col: CAMPAIGN_TABLE_COLMN_NAME.MONTHLY_LIMIT });
          if (e.target.name === 'saveBudgetByMonth') {
            onClickSaveMonthlyBudget(row, nameInput);
          } else if (e.target.name === 'resetName') {
            setIsEditingMonthlyBudget(null);
          } else// Still editing
          {
            const campaignBudgetUIState = getCampaignBudgetUIState({
              campaign_budgets: row.campaign_budgets,
              monthly_budget: row.monthly_budget,
              monthly_volume: row.monthly_volume,
            });
            if (isEditingMonthlyBudget?.row != rowIndex) {
              setSelecteMonth(getSelectBox(MonthlyBudgetType[0].options, campaignBudgetUIState?.monthly_limit_type || ''));
              setBudgetAndLimitInputs({ ...budgetAndLimitInputs, monthly_budget_units: campaignBudgetUIState?.monthly_budget_units });
            }
            setIsEditingMonthlyBudget({ row: rowIndex });
            setIsEditingDailyBudget(null);
            setIsEditingName(null);
          }
        },
      },
      formatExtraData: { canManageCampaign: canManageCampaign },
      formatter: (_cellContent, row, rowIndex, extra_data) => {
        const canManageCurrentCampaign = extra_data.canManageCampaign(row?.id);
        const isCampaignDiscarded = !!row.discarded_at;
        const campaignStyles = getCampaignStyles(isCampaignDiscarded);
        
        return (
          <div className="d-flex">
            <UncontrolledDropdown ref={isTextSelected ? '' : dropdownMenuRefCampaignMonthLimits} isOpen={((isEditingMonthlyBudget != null) && canManageCurrentCampaign && !isCampaignDiscarded && (isEditingMonthlyBudget.row == rowIndex))}>
              <DropdownToggle href="#" className='card-drop fsnormal' tag="i" {...campaignStyles.toggle}>
                {
                  (IsMonthlyBudgetFeatureEnabled(current_account, row?.product_type)) ?
                    <>
                      {(modify_campaign_loading === true)
                        && (loadingCell.row === rowIndex)
                        && (loadingCell.col === CAMPAIGN_TABLE_COLMN_NAME.MONTHLY_LIMIT) ? (<ModifyLoadingIcon color="secondary" />) : (
                        <>
                          <span className={`${campaignStyles.textClass || 'text-black'}`}>{getMonthlyBudgetStringForCell(row)}</span>
                          {
                            (canManageCurrentCampaign && !isCampaignDiscarded) && (
                              <span className={`ms-1 font-size-16 ${(rowIndex === editIconRow) ? '' : 'edit-hover-class'}`}>
                                <a><i className="mdi mdi-pencil text-success" /></a>
                              </span>)
                          }
                        </>

                      )
                      }
                    </> : <span className="text-sfdarkgrey">--</span>
                }
              </DropdownToggle>
              {!isCampaignDiscarded && (
                <DropdownMenu className="dropdown-menu-start">
                  <DropdownItem className="font-weight-semibold">Monthly Limit</DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem text style={{ width: '320px' }}>
                    <div className="d-flex flex-column">
                      <div className="fom-control mb-3 mt-1">
                        <Select
                          name="monthly_limit_type"
                          onChange={(e) => {
                            handleMonthlyLimits(e);
                          }}
                          value={selecteMonth}
                          options={MonthlyBudgetType}
                          classNamePrefix="select2-selection sf_dropdown_popup"
                          placeholder=""
                        />
                      </div>
                      <div className="fom-control">
                        {monthlyLimits_HTML}
                      </div>
                      <div className="ms-auto mt-2">
                        <button className={`btn btn-sm ${getPrimaryButtonClass()} mx-1`} name="saveBudgetByMonth" type="submit">Save</button>
                        <button className="btn btn-sm btn-light mx-1" name="resetName" type="reset">Cancel</button>
                      </div>
                    </div>
                  </DropdownItem>
                </DropdownMenu>
              )}
            </UncontrolledDropdown>
          </div>
        )
      },
      csvFormatter: (_cellContent, row, rowIndex) => {
        if (IsMonthlyBudgetFeatureEnabled(current_account, row?.product_type)) {
          const result = getMonthlyBudgetStringForCell(row);
          if (typeof result === 'string') {
            return result
          }
          if (result?.props?.suffix) {
            return `${SfCommaStringFormatter(result?.props?.value || 0)}${result?.props?.suffix}`
          }
          return SfDollarStringFormatter(result?.props?.value || 0.00)
        } else {
          return "--";
        }
      }
    }
  ]

  const columns = [
    ...commonColumnsForAllTypes,

    // queries are only shown in admin view
    {
      dataField: 'queries',
      isDataFieldName: true,
      hidden: (hide_col?.['click_analytic_queries'] === null) ? true : (hide_col?.['click_analytic_queries']),
      text: 'Opportunities',
      tooltipDescription: TOOLTIPS.QUERIES,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, row, rowIndex, loading_stats) => (loading_stats ? (<Skeleton />) : undefinedNullCellFormatter(cell)),
      formatExtraData: loading_stats,
      csvFormatter: (_cellContent, row, rowIndex) => undefinedNullCellFormatter(_cellContent),
      columnName: 'click_analytic_queries',
      csvExport: (current_account?.internal === true),
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
    },
    {
      dataField: 'campaign_pace',
      isDataFieldName: true,
      text: 'Pace',
      tooltipDescription: TOOLTIPS.CAMPAIGNS.GENERIC.PACE,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, row, rowIndex, loading_stats) => {
        return loading_stats ? (<Skeleton />) : (dollarFormatWithTwoDecimalPlaces(cell || '0.00'))
      },
      formatExtraData: loading_stats,
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_campaign_pace']),
      hidden: (hide_col?.['is_campaign_pace'] === null) ? true : (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CAMPAIGN_PACE) || hide_col?.['is_campaign_pace']),
      columnName: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CAMPAIGN_PACE) ? 'is_campaign_pace' : '',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DOLLAR_SIGN),
    },

    {
      dataField: 'searches',
      hidden: (hide_col?.['click_analytic_searches'] === null) ? true : (hide_col?.['click_analytic_searches']),
      text: 'Bids',
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.SEARCHES,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, row, rowIndex, loading_stats) => (loading_stats ? (<Skeleton />) : undefinedNullCellFormatter(cell)),
      formatExtraData: loading_stats,
      csvFormatter: (_cellContent, row, rowIndex) => undefinedNullCellFormatter(_cellContent),
      columnName: 'click_analytic_searches',
      csvExport: true,
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
      isDataFieldName: true
    },

    // impressions are only shown in admin view
    {
      dataField: 'impressions',
      hidden: (hide_col?.['click_analytic_impressions'] === null) ? true : (hide_col?.['click_analytic_impressions']),
      text: 'Impressions',
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CLICK_IMPRESSIONS,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, row, rowIndex, loading_stats) => (loading_stats ? (<Skeleton />) : undefinedNullCellFormatter(cell)),
      formatExtraData: loading_stats,
      csvFormatter: (_cellContent, row, rowIndex) => undefinedNullCellFormatter(_cellContent),
      columnName: 'click_analytic_impressions',
      csvExport: (current_account?.internal === true),
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
      isDataFieldName: true
    },

    {
      dataField: 'total_units',
      text: 'Units',
      hasInfoTooltip: true,
      tooltipDescription: 'Number of opportunities you have received',
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, row, rowIndex, loading_stats) => (loading_stats ? (<Skeleton />) : (cell == null ? (cell = 0) : cell.toLocaleString())),
      formatExtraData: loading_stats,
      csvFormatter: (_cellContent, row, rowIndex) => (_cellContent == null ? (_cellContent = 0) : _cellContent.toLocaleString()),
      hidden: hide_col?.['click_analytic_clicks'],
      columnName: 'click_analytic_clicks',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
      isDataFieldName: true
    },
    {
      dataField: 'avg_unit_cost',
      text: 'Cost Per Unit',
      hasInfoTooltip: true,
      tooltipDescription: 'Average cost of an opportunity',
      headerFormatter: forColumnHeaderWrapper,
      splitHeader: true,
      preferSingleWordFirstRow: true,
      sort: true,
      sortFunc: sortStringAsFloat,
      formatter: (cell, row, rowIndex, loading_stats) => (loading_stats ? (<Skeleton />) : (dollarFormatWithTwoDecimalPlaces(cell || '0.00'))),
      formatExtraData: loading_stats,
      csvFormatter: (_cellContent, row, rowIndex) => (_cellContent != (null || 0) ? SfDollarStringFormatter(_cellContent) : "0.00"),
      hidden: hide_col?.['click_analytic_cpc'],
      columnName: 'click_analytic_cpc',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DOLLAR_SIGN),
      isDataFieldName: true
    },
    {
      dataField: 'total_cost',
      text: 'Total Cost',
      hasInfoTooltip: true,
      tooltipDescription: 'Total cost of the campaign',
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      sortFunc: sortStringAsFloat,
      formatter: (cell, row, rowIndex, loading_stats) => (loading_stats ? (<Skeleton />) : (dollarFormatWithTwoDecimalPlaces(cell || '0.00'))),
      formatExtraData: loading_stats,
      csvFormatter: (_cellContent, row, rowIndex) => (_cellContent != (null || 0) ? SfDollarStringFormatter(_cellContent) : '0.00'),
      hidden: hide_col?.['click_analytic_total_payout'],
      columnName: 'click_analytic_total_payout',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DOLLAR_SIGN),
      isDataFieldName: true
    },
    {
      dataField: 'campaign_notes',
      text: 'Notes',
      footer: '',
      tooltipDescription: TOOLTIPS.CAMPAIGNS.GENERIC.NOTES,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: notesFormatter,
      formatExtraData: campaign_notes_loading,
      csvExport: false,
      hidden: (hide_col?.['is_campaign_notes'] === null) ? true : (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_NOTES_COLUMN_FOR_ADMIN_VIEW) || hide_col?.['is_campaign_notes']),
      columnName: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_NOTES_COLUMN_FOR_ADMIN_VIEW) ? 'is_campaign_notes' : '',
    },
    {
      dataField: 'click_analytic_prefill_success_rate',
      text: 'Prefill Success',
      hasInfoTooltip: true,
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.PERCENT_SIGN),
      isDataFieldName: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CLICKS.PREFILL_SUCCESS,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, row, _rowIndex, loading_stats) => (
        loading_stats ? (
          <Skeleton />
        ) : (
          row?.product_type?.name === NAME_OF_PRODUCT_TYPES.CLICKS ? (
            row?.click_analytic_clicks ? (
              <div>
                {SfPercentStringFormatter((cell * 100) || 0)}
                {(cell * 100) < 80 && <i className="mdi mdi-alert-circle-outline text-warning ms-1" />}
              </div>
            ) : '--'
          ) : '--'
        )
      ),
      formatExtraData: loading_stats,
      csvFormatter: (cellContent, row, _rowIndex) => row?.product_type?.name === NAME_OF_PRODUCT_TYPES.CLICKS ? SfPercentStringFormatter(cellContent * 100 || '0.00') : '--',
      hidden: IS_RTB_ACCOUNT ? true : (hide_col?.['is_prefill_success_rate'] === null) ? true : (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CLICK_ANALYTICS_PREFILL_FAILURE) || hide_col?.['is_prefill_success_rate']),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_prefill_success_rate']),
      columnName: !IS_RTB_ACCOUNT && isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CLICK_ANALYTICS_PREFILL_FAILURE) ? 'is_prefill_success_rate' : '',
    },
    {
      dataField: 'win_rate',
      text: 'Win Rate',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.PERCENT_SIGN),
      isDataFieldName: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CLICKS.WIN_RATE,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      sortFunc: sortStringAsFloat,
      formatter: (cell, _row, _rowIndex, loading_stats) => (loading_stats ? (<Skeleton />) : percentFormatWithTwoDecimalPlaces(cell * 100 || 0)),
      formatExtraData: loading_stats,
      csvExport: false,
      hidden: (hide_col?.['is_win_rate'] === null) ? true : bsh_isAdminUserDetailsPresent() ? isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_WIN_RATE) ? hide_col?.['is_win_rate'] : true : true,
      columnName: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_WIN_RATE) && bsh_isAdminUserDetailsPresent() ? 'is_win_rate' : '',
    }
  ];

  const profitAndCRColumns = [
    {
      dataField: "profit",
      text: "Profit",
      footer: '',
      isDataFieldName: true,
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DOLLAR_SIGN),
      hasInfoTooltip: true,
      tooltipDescription: 'Revenue generated from this campaign',
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      columnName: new_campaign_page_feature_flag_active ? (selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CLICKS ? 'is_click_profit' :
        selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.LEADS ? 'is_lead_profit' :
          selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CALLS ? 'is_call_profit' : 'profit') : 'profit',
      sortFunc: sortStringAsFloat,
      hidden: nullHandlerCustomizeColumns(new_campaign_page_feature_flag_active ? (selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CLICKS ? hide_col?.['is_click_profit'] :
        selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.LEADS ? hide_col?.['is_lead_profit'] :
          selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CALLS ? hide_col?.['is_call_profit'] : hide_col?.['profit']) : hide_col?.['profit']),
      formatter: (_cellContent, row, rowIndex, loading) => (
        (loading.loading_stats || loading.click_conversion_pixels_aggregated_loading) ? (<Skeleton />) : loading.show_pixel_stats_for_leads_and_calls ? ((isFinite(_cellContent) & isFinite(row?.revenue)) ? SfDollarStringFormatter(_cellContent || 0) : '--') :
          row?.product_type?.name === NAME_OF_PRODUCT_TYPES.CLICKS ? (isFinite(_cellContent) & isFinite(row?.revenue) ? SfDollarStringFormatter(_cellContent || 0) : '--') : '--'
      ),
      formatExtraData: { loading_stats: loading_stats, click_conversion_pixels_aggregated_loading: click_conversion_pixels_aggregated_loading, show_pixel_stats_for_leads_and_calls: show_pixel_stats_for_leads_and_calls },
      csvFormatter: (_cellContent, row, rowIndex) => show_pixel_stats_for_leads_and_calls ? (isFinite(_cellContent) & isFinite(row?.revenue)) ? SfDollarStringFormatter(_cellContent) : '0' :
        row?.product_type?.name === NAME_OF_PRODUCT_TYPES.CLICKS ? (isFinite(_cellContent) & isFinite(row?.revenue) ? SfDollarStringFormatter(_cellContent) : '--') : '--',
      csvExport: !(nullHandlerCustomizeColumns(new_campaign_page_feature_flag_active ? (selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CLICKS ? hide_col?.['is_click_profit'] :
        selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.LEADS ? hide_col?.['is_lead_profit'] :
          selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CALLS ? hide_col?.['is_call_profit'] : hide_col?.['profit']) : hide_col?.['profit'])),

    },
    {
      dataField: "contribution_margin",
      isDataFieldName: true,
      text: "CM",
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.PERCENT_SIGN),
      hasInfoTooltip: true,
      tooltipDescription: 'Contribution margin',
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      sortFunc: sortStringAsFloat,
      hidden: nullHandlerCustomizeColumns(new_campaign_page_feature_flag_active ? (selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CLICKS ? hide_col?.['is_click_cm'] :
        selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.LEADS ? hide_col?.['is_lead_cm'] :
          selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CALLS ? hide_col?.['is_call_cm'] : hide_col?.['contribution_margin']) : hide_col?.['contribution_margin']),
      columnName: new_campaign_page_feature_flag_active ? (selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CLICKS ? 'is_click_cm' :
        selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.LEADS ? 'is_lead_cm' :
          selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CALLS ? 'is_call_cm' : 'contribution_margin') : 'contribution_margin',
      formatter: (cellContent, row, _rowIndex, loading) => (
        (loading.loading_stats || loading.click_conversion_pixels_aggregated_loading) ? (<Skeleton />) : loading.show_pixel_stats_for_leads_and_calls ? (isFinite(cellContent) & isFinite(row?.revenue) ? SfPercentStringFormatter(cellContent || 0) : '--') :
          row?.product_type?.name === NAME_OF_PRODUCT_TYPES.CLICKS ? (isFinite(cellContent) & isFinite(row?.revenue) > 0 ? SfPercentStringFormatter(cellContent || 0) : '--') : '--'
      ),
      formatExtraData: { loading_stats: loading_stats, click_conversion_pixels_aggregated_loading: click_conversion_pixels_aggregated_loading, show_pixel_stats_for_leads_and_calls: show_pixel_stats_for_leads_and_calls },
      csvFormatter: (cellContent, row, _rowIndex) => show_pixel_stats_for_leads_and_calls ? (isFinite(cellContent) & isFinite(row?.revenue) ? SfPercentStringFormatter(cellContent || 0) : '--') :
        row?.product_type?.name === NAME_OF_PRODUCT_TYPES.CLICKS ? (isFinite(cellContent) & isFinite(row?.revenue) ? SfPercentStringFormatter(cellContent || 0) : '--') : '--',
      csvExport: !(nullHandlerCustomizeColumns(new_campaign_page_feature_flag_active ? (selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CLICKS ? hide_col?.['is_click_cm'] :
        selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.LEADS ? hide_col?.['is_lead_cm'] :
          selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CALLS ? hide_col?.['is_call_cm'] : hide_col?.['contribution_margin']) : hide_col?.['contribution_margin'])),
    }
  ]

  const totalConversionandRevenueColumns = [
    {
      dataField: 'total_conversions',
      text: 'Total Conversions',
      footer: '',
      isDataFieldName: true,
      formatter: (_cellContent, row, _rowIndex, formatExtraData) => {
        return formatExtraData?.loading ? (<Skeleton />) : SfCommaStringFormatter(row?.total_conversions);
      },
      csvFormatter: (_cellContent, row) => {
        return SfCommaStringFormatter(row?.total_conversions);
      },
      formatExtraData: {
        loading: click_conversion_pixels_aggregated_loading || lead_conversion_pixels_agg_loading || call_conversion_pixels_agg_loading,
        show_pixel_stats_for_leads_and_calls: show_pixel_stats_for_leads_and_calls,
      },
      columnName: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_CONVERSION_AND_REVENUE_METRICS) ? 'is_total_conversions' : '',
      hidden: nullHandlerCustomizeColumns(hide_col?.['is_total_conversions']),
      hasBothTooltips: true,
      sort: true,
      tooltipDescription: 'Total Conversions',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_total_conversions']),
    },
    {
      dataField: 'total_revenue',
      text: 'Total Revenue',
      footer: '',
      isDataFieldName: true,
      tooltipDescription: 'Total Revenue',
      formatter: (_cellContent, row, _rowIndex, formatExtraData) => {
        return formatExtraData?.loading ? (<Skeleton />) : SfDollarStringFormatter(row?.total_revenue);
      },
      formatExtraData: {
        loading: click_conversion_pixels_aggregated_loading || lead_conversion_pixels_agg_loading || call_conversion_pixels_agg_loading,
        show_pixel_stats_for_leads_and_calls: show_pixel_stats_for_leads_and_calls,
      },
      sort: true,
      columnName: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_CONVERSION_AND_REVENUE_METRICS) ? 'is_total_revenue' : '',
      hasBothTooltips: true,
      hidden: nullHandlerCustomizeColumns(hide_col?.['is_total_revenue']),
      csvFormatter: (_cellContent, row) => {
        return SfDollarStringFormatter(row?.total_revenue);
      },
      sortFunc: sortStringAsFloat,
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DOLLAR_SIGN),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_total_revenue']),
    }
  ]

  const defaultSorted = [
    createDefaultColumnSortedObject('total_cost', 'desc')
  ];
  // Select All Button operation
  const selectRow = {
    mode: 'checkbox',
    hideSelectColumn: !canCreateNewCampaign,
    nonSelectable: campaigns.filter(c => !canManageCampaign(c?.id) || c.product_type_id === PRODUCT_TYPE_IDS.SYNDI_CLICKS || c.discarded_at).map(c => c.id),
    selected: selectedRows.map((row) => row.id),
    onSelectAll: (isSelect, rows, _e) => {
      resetPopupModal(); // reset popup Modal (edit name, edit daily limit, edit monthly limit)

      if (isSelect) {
        setSelectedRows(rows);
      } else {
        setSelectedRows([]);
      }
    },
    onSelect: (row, isSelect, _rowIndex, _e) => {
      resetPopupModal(); // reset popup Modal (edit name, edit daily limit, edit monthly limit)

      setSelectedRows((prevSelectedRows) => {
        const newSelectedRows = prevSelectedRows.filter((sRow) => (sRow.id !== row.id));
        if (isSelect) {
          newSelectedRows.push(row);
        }
        return newSelectedRows;
      });
    }
  };


  const [customizeColumnsModal, setCustomizeColumnsModal] = useState({ isActiveModal: false, columns: [] });

  //For CustomizeColumns Modal Close 
  const onClickOpenCustomizeColumnsModal = () => {
    let userColumnPreferenceFields = [];
    let filteredDynamicColumns = [];

    if (isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_USER_COLUMN_PREFERENCE)) {
      userColumnPreferenceFields = [...mapped_final_columns].filter(single_obj => {
        if (hide_col?.[single_obj?.columnName] === false) {
          return single_obj;
        }
        if (hide_col?.[single_obj?.columnName]) {
          return single_obj;
        }
      });

      filteredDynamicColumns = [...dynamicColumns].filter(single_obj => {
        if (hide_col?.[single_obj?.pixelColumn?.name] === null) {
          return false;
        }
        return true
      });
    }

    const columns = [...userColumnPreferenceFields, ...filteredDynamicColumns];
    const columnOrders = columns.map((item, index) => ({ [item.columnName]: (campaigns_customize_order?.[selectedProductGroup?.label]?.[item.columnName] || index) + 1 })).reduce((prev, current) => ({ ...prev, ...current }), {});
    const sortedCustomizeColumns = sortColumnsByOrder(columns, columnOrders);
    if (new_campaign_page_feature_flag_active) {
      if (selectedProductGroup.value === NAME_OF_PRODUCT_TYPES.CLICKS || !selectedProductGroup.value) {
        setCustomizeColumnsModal({
          columns: !isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_CAMPAIGNS_PAGE) ? columns : sortedCustomizeColumns,
          isActiveModal: true
        });
      } else if (show_pixel_stats_for_leads_and_calls && (selectedProductGroup.value === NAME_OF_PRODUCT_TYPES.LEADS || selectedProductGroup.value === NAME_OF_PRODUCT_TYPES.CALLS)) {
        setCustomizeColumnsModal({
          columns: !isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_CAMPAIGNS_PAGE) ? columns : sortedCustomizeColumns,
          isActiveModal: true
        });
      }
      else {
        setCustomizeColumnsModal({
          columns: !isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_CAMPAIGNS_PAGE) ? columns : sortedCustomizeColumns,
          isActiveModal: true
        });
      }
    } else {
      setCustomizeColumnsModal({
        columns: !isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_CAMPAIGNS_PAGE) ? columns : sortedCustomizeColumns,
        isActiveModal: true
      });
    }
  }

  const onClickCloseCustomizeColumns = () => {
    setCustomizeColumnsModal({
      columns: [],
      isActiveModal: false
    });
  }
  const onSubmitCustomizeColumnsModal = (values) => {
    if (isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_USER_COLUMN_PREFERENCE)) {
      const userColumnPreferenceFields = values.filter(single_obj => {
        if (hide_col?.[single_obj?.columnName] === false) {
          return single_obj;
        }
        if (hide_col?.[single_obj?.columnName]) {
          return single_obj;
        }
      });

      const userColumnPreference = userColumnPreferenceFields.map(singleColumn => {
        return ({ [singleColumn?.columnName]: singleColumn?.hidden })

      }).reduce((prev, current) => ({ ...prev, ...current }), {});
      const data = {
        user_column_preference_campaign: {
          ...userColumnPreference,
          id: user_column_preference_campaign?.id,
          user_id: user_column_preference_campaign?.admin_user_id,
        }
      }
      const updateColumnOrders = values.map((item, index) => ({ [item.columnName]: index + 1 })).reduce((prev, current) => ({ ...prev, ...current }), {});
      const finalColumnOrders = {
        ...campaigns_customize_order,
        [selectedProductGroup?.label]: updateColumnOrders
      }
      { isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_CAMPAIGNS_PAGE) && dispatch(updateCustomizeOrder({ id: campaigns_customize_order_for_campaigns.id, component: PAGES_FOR_DRAGGABLE_CUSTOMIZE_COLUMN.CAMPAIGNS, values: JSON.stringify(finalColumnOrders) })) }
      dispatch(updateCampaignStickyColumns(data));
    }
    if ((isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_PIXEL_STATS_FOR_CAMPAIGNS))) {

      // For Pixel Columns
      const pixelValues = values.filter(single_obj => {
        if (hide_col?.[single_obj?.columnName] === undefined) {
          return single_obj;
        }
      });

      const finalPixels = activeConversionPixels
        .map(single_pixel => ({
          id: single_pixel.id,
          campaign_pixel_column: single_pixel?.campaign_pixel_column
        }));
      setDynamicColumns(pixelValues);

      for (const single_pixel_obj of pixelValues) {
        const finalPixelIndex = finalPixels.findIndex(
          finalpx => finalpx.id === single_pixel_obj.pixelColumn.id
        )
        if (finalPixelIndex == -1) {
          continue
        }
        if (!finalPixels[finalPixelIndex].campaign_pixel_column) {
          finalPixels[finalPixelIndex].campaign_pixel_column = {}
        }
        finalPixels[finalPixelIndex].campaign_pixel_column[
          single_pixel_obj.pixelColumn.name
        ] = single_pixel_obj.hidden === false
      }

      for (const single_pixel_column_row of finalPixels) {
        dispatch(modifyClickConversionPixels(single_pixel_column_row))
      }
    }

    onClickCloseCustomizeColumns();
  }

  const handleColumns = singe_obj => {
    setCustomizeColumnsModal(preState => {
      const tempPrevState = preState?.columns.map(prev =>
        prev.text === singe_obj.text && prev.dataField === singe_obj.dataField
          ? { ...singe_obj, hidden: !singe_obj.hidden }
          : prev
      )
      return { ...preState, columns: tempPrevState }
    })
  }

  const groupByCampaignId = () => {
    const notes = {};
    campaign_notes.forEach((item) => {
      const campaign_id = item.campaign_id;
      if (!notes[campaign_id]) {
        notes[campaign_id] = [];
      }
      notes[campaign_id].push(item);
    });

    return Object.values(notes);
  }

  const getNotesGroupByCampaignId = (campaign_id) => {
    const allNotesGroups = groupByCampaignId();
    return allNotesGroups.find(subArray => subArray.some(item => item.campaign_id === campaign_id)) || [];
  }

  const getNotesCountByCampaignId = (campaign_id) => {
    return campaign_notes.filter((item) => item.campaign_id === campaign_id)?.length || 0;
  }

  const genericColumns = [
    {
      dataField: 'total_units',
      text: 'Units',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: 'Number of opportunities you have received',
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, row, rowIndex, loading_stats) => (loading_stats ? (<Skeleton />) : (cell == null ? (cell = 0) : Sfdelimitter(cell))),
      formatExtraData: loading_stats,
      csvFormatter: (cellContent, _row, _rowIndex) => (cellContent == null ? (cellContent = 0) : SfCommaStringFormatter(cellContent)),
      hidden: nullHandlerCustomizeColumns(hide_col?.['is_generic_units']),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_generic_units']),
      columnName: 'is_generic_units',
    },
    {
      dataField: 'avg_bid',
      text: 'Avg Bid',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DOLLAR_SIGN),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.GENERIC.AVG_BID,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, row, rowIndex, loading_stats) => (loading_stats ? (<Skeleton />) : (dollarFormatWithTwoDecimalPlaces(cell || '0.00'))),
      formatExtraData: loading_stats,
      csvFormatter: (_cellContent, row, rowIndex) => (SfDollarStringFormatter(_cellContent || '0.00')),
      hidden: nullHandlerCustomizeColumns(hide_col?.['is_generic_avg_bid']),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_generic_avg_bid']),
      columnName: 'is_generic_avg_bid',
    },
    {
      dataField: 'avg_unit_cost',
      text: 'CPX',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DOLLAR_SIGN),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.GENERIC.CPX,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, loading_stats) => (loading_stats ? (<Skeleton />) : (dollarFormatWithTwoDecimalPlaces(cell || 0))),
      formatExtraData: loading_stats,
      csvFormatter: (_cellContent, row, rowIndex) => (SfDollarStringFormatter(_cellContent || '0.00')),
      hidden: nullHandlerCustomizeColumns(hide_col?.['is_generic_cpx']),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_generic_cpx']),
      columnName: 'is_generic_cpx',
    },
    {
      dataField: 'campaign_pace',
      text: 'Pace',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DOLLAR_SIGN),
      isDataFieldName: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.GENERIC.PACE,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, row, rowIndex, loading_stats) => {
        return loading_stats ? (<Skeleton />) : (dollarFormatWithTwoDecimalPlaces(cell || '0.00'))
      },
      formatExtraData: loading_stats,
      csvFormatter: (cellContent, _row, _rowIndex) => (SfDollarStringFormatter(cellContent || '0.00')),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_campaign_pace']),
      hidden: (hide_col?.['is_campaign_pace'] === null) ? true : (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CAMPAIGN_PACE) || hide_col?.['is_campaign_pace']),
      columnName: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CAMPAIGN_PACE) ? 'is_campaign_pace' : '',
    },
    {
      dataField: 'total_cost',
      text: 'Spend',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DOLLAR_SIGN),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.GENERIC.SPEND,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      sortFunc: sortStringAsFloat,
      formatter: (cell, row, rowIndex, loading_stats) => (loading_stats ? (<Skeleton />) : (dollarFormatWithTwoDecimalPlaces(cell || '0.00'))),
      formatExtraData: loading_stats,
      csvFormatter: (_cellContent, row, rowIndex) => (SfDollarStringFormatter(_cellContent || '0.00')),
      hidden: nullHandlerCustomizeColumns(hide_col?.['is_generic_spend']),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_generic_spend']),
      columnName: 'is_generic_spend',
    },
    {
      dataField: 'campaign_notes',
      text: 'Notes',
      footer: '',
      tooltipDescription: TOOLTIPS.CAMPAIGNS.GENERIC.NOTES,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: notesFormatter,
      formatExtraData: campaign_notes_loading,
      csvExport: false,
      hidden: (hide_col?.['is_campaign_notes'] === null) ? true : (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_NOTES_COLUMN_FOR_ADMIN_VIEW) || hide_col?.['is_campaign_notes']),
      columnName: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_NOTES_COLUMN_FOR_ADMIN_VIEW) ? 'is_campaign_notes' : '',
    },
    {
      dataField: 'win_rate',
      text: 'Win Rate',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.PERCENT_SIGN),
      isDataFieldName: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CLICKS.WIN_RATE,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      sortFunc: sortStringAsFloat,
      formatter: (cell, _row, _rowIndex, loading_stats) => (loading_stats ? (<Skeleton />) : percentFormatWithTwoDecimalPlaces(cell * 100 || 0)),
      formatExtraData: loading_stats,
      csvExport: false,
      hidden: (hide_col?.['is_win_rate'] === null) ? true : bsh_isAdminUserDetailsPresent() ? isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_WIN_RATE) ? hide_col?.['is_win_rate'] : true : true,
      columnName: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_WIN_RATE) && bsh_isAdminUserDetailsPresent() ? 'is_win_rate' : '',
    }
  ]

  const clicksColumns = [
    {
      dataField: 'click_analytic_total_inventory',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
      isDataFieldName: true,
      text: 'Inventory',
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CLICKS.INVENTORY,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, extraData) => {
        const { qf_agg_campaigns_loading, click_campaign_stats_loading } = extraData;
        return (click_campaign_stats_loading || qf_agg_campaigns_loading)
          ? (<Skeleton />)
          : Sfdelimitter(cell || 0);
      },
      formatExtraData: { qf_agg_campaigns_loading, click_campaign_stats_loading },
      csvFormatter: (_cellContent, row, rowIndex) => (_cellContent == null ? (_cellContent = 0) : _cellContent.toLocaleString()),
      hidden: nullHandlerCustomizeColumns(hide_col?.['is_click_inventory']),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_click_inventory']),
      columnName: 'is_click_inventory',
    },
    {
      dataField: 'click_analytic_total_opportunities',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
      isDataFieldName: true,
      text: 'Opportunities',
      tooltipDescription: TOOLTIPS.BIDS,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, extraData) => {
        const { qf_agg_campaigns_loading, click_campaign_stats_loading } = extraData;
        return (click_campaign_stats_loading || qf_agg_campaigns_loading)
          ? (<Skeleton />)
          : Sfdelimitter(cell || 0);
      },
      formatExtraData: { qf_agg_campaigns_loading, click_campaign_stats_loading },
      csvFormatter: (_cellContent, row, rowIndex) => (_cellContent == null ? (_cellContent = 0) : _cellContent.toLocaleString()),
      hidden: nullHandlerCustomizeColumns(hide_col?.['is_click_opportunities']),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_click_opportunities']),
      columnName: 'is_click_opportunities',
    },
    {
      dataField: 'click_analytic_target_rate',
      text: 'Target Rate',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.PERCENT_SIGN),
      isDataFieldName: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CLICKS.TARGET_RATE,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, extraData) => {
        const { qf_agg_campaigns_loading, click_campaign_stats_loading } = extraData;
        return (click_campaign_stats_loading || qf_agg_campaigns_loading)
          ? (<Skeleton />)
          : SfPercentStringFormatter(cell || 0);
      },
      formatExtraData: { qf_agg_campaigns_loading, click_campaign_stats_loading },
      csvFormatter: (cellContent, _row, _rowIndex) => SfPercentStringFormatter(cellContent || '0.00'),
      hidden: nullHandlerCustomizeColumns(hide_col?.['is_click_target_rate']),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_click_target_rate']),
      columnName: 'is_click_target_rate',
    },
    {
      dataField: 'click_analytic_total_searches',
      text: 'Bids',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
      isDataFieldName: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CLICKS.BIDS,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, extraData) => {
        const { qf_agg_campaigns_loading, click_campaign_stats_loading } = extraData;
        return (click_campaign_stats_loading || qf_agg_campaigns_loading)
          ? (<Skeleton />)
          : Sfdelimitter(cell || 0);
      },
      formatExtraData: { qf_agg_campaigns_loading, click_campaign_stats_loading },
      csvFormatter: (cellContent, _row, _rowIndex) => SfCommaStringFormatter(cellContent || 0),
      hidden: nullHandlerCustomizeColumns(hide_col?.['is_click_bids']),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_click_bids']),
      columnName: 'is_click_bids',
    },
    {
      dataField: 'click_analytic_bid_rate',
      text: 'Bid Rate',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.PERCENT_SIGN),
      isDataFieldName: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CLICKS.BID_RATE,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, extraData) => {
        const { qf_agg_campaigns_loading, click_campaign_stats_loading } = extraData;
        return (click_campaign_stats_loading || qf_agg_campaigns_loading)
          ? (<Skeleton />)
          : SfPercentStringFormatter((cell * 100) || 0);
      },
      formatExtraData: { qf_agg_campaigns_loading, click_campaign_stats_loading },
      csvFormatter: (cellContent, _row, _rowIndex) => SfPercentStringFormatter(cellContent * 100 || '0.00'),
      hidden: nullHandlerCustomizeColumns(hide_col?.['is_click_bid_rate']),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_click_bid_rate']),
      columnName: 'is_click_bid_rate',
    },
    {
      dataField: 'click_analytic_impressions',
      text: 'Impressions',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CLICK_IMPRESSIONS,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      // Fix: Use both loading states to prevent showing stale data before qf_agg_campaigns_data loads.
      // This prevents the impressions column from displaying incorrectly formatted values (0.00% instead of 0)
      // when qf_agg_campaigns_data hasn't loaded yet but click_campaign_stats has.
      formatter: (cell, _row, _rowIndex, extraData) => {
        const { qf_agg_campaigns_loading, click_campaign_stats_loading } = extraData;
        return (click_campaign_stats_loading || qf_agg_campaigns_loading)
          ? (<Skeleton />)
          : Sfdelimitter(cell || 0);
      },
      formatExtraData: { qf_agg_campaigns_loading, click_campaign_stats_loading },
      csvFormatter: (cellContent, _row, _rowIndex) => SfCommaStringFormatter(cellContent || 0),
      hidden: hide_col?.['is_click_impressions'],
      csvExport: !hide_col?.['is_click_impressions'],
      columnName: 'is_click_impressions',
    },
    {
      dataField: 'click_analytic_total_clicks',
      text: 'Clicks',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CLICKS.TOTAL_CLICKS,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, click_campaign_stats_loading) => (click_campaign_stats_loading ? (<Skeleton />) : Sfdelimitter(cell || 0)),
      formatExtraData: click_campaign_stats_loading,
      csvFormatter: (cellContent, _row, _rowIndex) => SfCommaStringFormatter(cellContent || 0),
      hidden: hide_col?.['is_click_total_clicks'],
      csvExport: !hide_col?.['is_click_total_clicks'],
      columnName: 'is_click_total_clicks',
    },
    {
      dataField: 'leads_generated_count',
      text: 'Leads',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: 'Total Leads',
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, row, rowIndex, loading_stats) => (loading_stats ? (<Skeleton />) : (cell == null ? (cell = 0) : cell.toLocaleString())),
      formatExtraData: loading_stats,
      csvFormatter: (_cellContent, row, rowIndex) => (_cellContent == null ? (_cellContent = 0) : _cellContent.toLocaleString()),
      hidden: hide_col?.['is_click_total_leads'] || !isGoalBrand,
      columnName: isGoalBrand ? 'is_click_total_leads' : '',
    },
    {
      dataField: 'calls_generated_count',
      text: 'Calls',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: 'Total Calls',
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, row, rowIndex, loading_stats) => (loading_stats ? (<Skeleton />) : (cell == null ? (cell = 0) : cell.toLocaleString())),
      formatExtraData: loading_stats,
      csvFormatter: (_cellContent, row, rowIndex) => (_cellContent == null ? (_cellContent = 0) : _cellContent.toLocaleString()),
      hidden: hide_col?.['is_click_total_calls'] || !isGoalBrand,
      columnName: isGoalBrand ? 'is_click_total_calls' : '',
    },
    {
      dataField: 'click_analytic_success_rate',
      text: 'CTR',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.PERCENT_SIGN),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CLICKS.CTR,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, click_campaign_stats_loading) => (click_campaign_stats_loading ? (<Skeleton />) : percentFormatWithTwoDecimalPlaces(cell * 100 || 0)),
      formatExtraData: click_campaign_stats_loading,
      csvFormatter: (cellContent, _row, _rowIndex) => SfPercentStringFormatter(cellContent * 100 || '0.00'),
      hidden: hide_col?.['is_click_success_rate'],
      csvExport: !hide_col?.['is_click_success_rate'],
      columnName: 'is_click_success_rate',
    },
    {
      dataField: 'click_analytic_avg_bid',
      text: 'Avg Bid',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DOLLAR_SIGN),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CLICKS.AVG_BID,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, click_campaign_stats_loading) => (click_campaign_stats_loading ? (<Skeleton />) : dollarFormatWithTwoDecimalPlaces(cell || 0)),
      formatExtraData: click_campaign_stats_loading,
      hidden: hide_col?.['is_click_avg_bid'],
      columnName: 'is_click_avg_bid',
      csvExport: !hide_col?.['is_click_avg_bid'],
      csvFormatter: (cellContent, _row, _rowIndex) => SfDollarStringFormatter(cellContent || '0.00'),
    },
    {
      dataField: 'click_analytic_avg_cpc',
      text: 'CPC',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DOLLAR_SIGN),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CLICKS.COST_PER,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, click_campaign_stats_loading) => (click_campaign_stats_loading ? (<Skeleton />) : dollarFormatWithTwoDecimalPlaces(cell || 0)),
      formatExtraData: click_campaign_stats_loading,
      hidden: hide_col?.['is_click_avg_cpc'],
      columnName: 'is_click_avg_cpc',
      csvExport: !hide_col?.['is_click_avg_cpc'],
      csvFormatter: (cellContent, _row, _rowIndex) => SfDollarStringFormatter(cellContent || '0.00'),
    },
    {
      dataField: 'campaign_pace',
      text: 'Pace',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DOLLAR_SIGN),
      isDataFieldName: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.GENERIC.PACE,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, row, rowIndex, loading_stats) => {
        return loading_stats ? (<Skeleton />) : (dollarFormatWithTwoDecimalPlaces(cell || '0.00'))
      },
      formatExtraData: loading_stats,
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_campaign_pace']),
      hidden: (hide_col?.['is_campaign_pace'] === null) ? true : (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CAMPAIGN_PACE) || hide_col?.['is_campaign_pace']),
      columnName: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CAMPAIGN_PACE) ? 'is_campaign_pace' : '',
    },
    {
      dataField: 'total_cost',
      text: 'Spend',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DOLLAR_SIGN),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CLICKS.SPEND,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      sortFunc: sortStringAsFloat,
      formatter: (cell, _row, _rowIndex, click_campaign_stats_loading) => (click_campaign_stats_loading ? (<Skeleton />) : dollarFormatWithTwoDecimalPlaces(cell || 0)),
      formatExtraData: click_campaign_stats_loading,
      hidden: hide_col?.['is_click_total_cost'],
      columnName: 'is_click_total_cost',
      csvExport: !hide_col?.['is_click_total_cost'],
      csvFormatter: (cellContent, _row, _rowIndex) => SfDollarStringFormatter(cellContent || '0.00'),
    },
    {
      dataField: 'campaign_notes',
      text: 'Notes',
      footer: '',
      tooltipDescription: TOOLTIPS.CAMPAIGNS.GENERIC.NOTES,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: false,
      formatter: notesFormatter,
      formatExtraData: campaign_notes_loading,
      csvExport: false,
      hidden: (hide_col?.['is_campaign_notes'] === null) ? true : (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_NOTES_COLUMN_FOR_ADMIN_VIEW) || hide_col?.['is_campaign_notes']),
      columnName: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_NOTES_COLUMN_FOR_ADMIN_VIEW) ? 'is_campaign_notes' : '',
    },
    {
      dataField: 'click_analytic_prefill_success_rate',
      text: 'Prefill Success',
      hasInfoTooltip: true,
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.PERCENT_SIGN),
      isDataFieldName: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CLICKS.PREFILL_SUCCESS,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, row, _rowIndex, click_campaign_stats_loading) => (click_campaign_stats_loading ? (<Skeleton />) : (
        row?.click_analytic_total_clicks ? (
          <div>
            {SfPercentStringFormatter((cell * 100) || 0)}
            {(cell * 100) < 80 && <i className="mdi mdi-alert-circle-outline text-warning ms-1" />}
          </div>
        ) : '--'
      )
      ),
      formatExtraData: click_campaign_stats_loading,
      csvFormatter: (cellContent, _row, _rowIndex) => SfPercentStringFormatter(cellContent * 100 || '0.00'),
      hidden: IS_RTB_ACCOUNT ? true : (hide_col?.['is_prefill_success_rate'] === null) ? true : (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CLICK_ANALYTICS_PREFILL_FAILURE) || hide_col?.['is_prefill_success_rate']),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_prefill_success_rate']),
      columnName: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CLICK_ANALYTICS_PREFILL_FAILURE) ? 'is_prefill_success_rate' : '',
    },
    {
      dataField: 'win_rate',
      text: 'Win Rate',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.PERCENT_SIGN),
      isDataFieldName: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CLICKS.WIN_RATE,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      sortFunc: sortStringAsFloat,
      formatter: (cell, _row, _rowIndex, click_campaign_stats_loading) => (click_campaign_stats_loading ? (<Skeleton />) : percentFormatWithTwoDecimalPlaces(cell * 100 || 0)),
      formatExtraData: click_campaign_stats_loading,
      csvExport: false,
      hidden: (hide_col?.['is_win_rate'] === null) ? true : bsh_isAdminUserDetailsPresent() ? isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_WIN_RATE) ? hide_col?.['is_win_rate'] : true : true,
      columnName: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_WIN_RATE) && bsh_isAdminUserDetailsPresent() ? 'is_win_rate' : '',
    }
  ]

  const callsColumns = [
    {
      dataField: 'call_analytic_total_inventory',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
      isDataFieldName: true,
      text: 'Inventory',
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CALLS.INVENTORY,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, loading_all_cmps_call_stats) => (loading_all_cmps_call_stats ? (<Skeleton />) : Sfdelimitter(cell || 0)),
      formatExtraData: loading_all_cmps_call_stats,
      csvFormatter: (cellContent, _row, _rowIndex) => SfCommaStringFormatter(cellContent || 0),
      hidden: nullHandlerCustomizeColumns(hide_col?.['is_call_inventory']),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_call_inventory']),
      columnName: 'is_call_inventory',
    },
    {
      dataField: 'call_analytic_total_opportunities',
      text: 'Opportunities',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
      isDataFieldName: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CALLS.QUERIES,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, loading_all_cmps_call_stats) => (loading_all_cmps_call_stats ? (<Skeleton />) : Sfdelimitter(cell || 0)),
      formatExtraData: loading_all_cmps_call_stats,
      csvFormatter: (cellContent, _row, _rowIndex) => SfCommaStringFormatter(cellContent || 0),
      hidden: nullHandlerCustomizeColumns(hide_col?.['is_call_opportunities']),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_call_opportunities']),
      columnName: 'is_call_opportunities',
    },
    {
      dataField: 'call_analytic_target_rate',
      text: 'Target Rate',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.PERCENT_SIGN),
      isDataFieldName: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CALLS.TARGET_RATE,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, loading_all_cmps_call_stats) => (loading_all_cmps_call_stats ? (<Skeleton />) : percentFormatWithTwoDecimalPlaces(cell || 0)),
      formatExtraData: loading_all_cmps_call_stats,
      csvFormatter: (cellContent, _row, _rowIndex) => SfPercentStringFormatter(cellContent || 0),
      hidden: nullHandlerCustomizeColumns(hide_col?.['is_call_target_rate']),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_call_target_rate']),
      columnName: 'is_call_target_rate',
    },
    {
      dataField: 'call_analytic_total_searches',
      text: 'Bids',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
      isDataFieldName: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CALLS.SEARCHES,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, loading_all_cmps_call_stats) => (loading_all_cmps_call_stats ? (<Skeleton />) : Sfdelimitter(cell || 0)),
      formatExtraData: loading_all_cmps_call_stats,
      csvFormatter: (cellContent, _row, _rowIndex) => SfCommaStringFormatter(cellContent || 0),
      hidden: nullHandlerCustomizeColumns(hide_col?.['is_call_bids']),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_call_bids']),
      columnName: 'is_call_bids',
    },
    {
      dataField: 'call_analytic_bid_rate',
      text: 'Bid Rate',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.PERCENT_SIGN),
      isDataFieldName: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CALLS.BID_RATE,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, loading_all_cmps_call_stats) => (loading_all_cmps_call_stats ? (<Skeleton />) : percentFormatWithTwoDecimalPlaces(cell || 0)),
      formatExtraData: loading_all_cmps_call_stats,
      csvFormatter: (cellContent, _row, _rowIndex) => SfPercentStringFormatter(cellContent || 0),
      hidden: nullHandlerCustomizeColumns(hide_col?.['is_call_bid_rate']),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_call_bid_rate']),
      columnName: 'is_call_bid_rate',
    },
    {
      dataField: 'call_analytic_total_calls',
      text: 'Transfers',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CALLS.TRANSFERS,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, loading_all_cmps_call_stats) => (loading_all_cmps_call_stats ? (<Skeleton />) : Sfdelimitter(cell || 0)),
      formatExtraData: loading_all_cmps_call_stats,
      csvFormatter: (cellContent, _row, _rowIndex) => SfCommaStringFormatter(cellContent || 0),
      hidden: hide_col?.['is_call_transfers'],
      csvExport: !hide_col?.['is_call_transfers'],
      columnName: 'is_call_transfers',
    },
    {
      dataField: 'call_analytic_total_accepted',
      text: 'Qualified Calls',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CALLS.QUALIFIED_CALLS,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, loading_all_cmps_call_stats) => (loading_all_cmps_call_stats ? (<Skeleton />) : Sfdelimitter(cell || 0)),
      formatExtraData: loading_all_cmps_call_stats,
      csvFormatter: (cellContent, _row, _rowIndex) => SfCommaStringFormatter(cellContent || 0),
      hidden: hide_col?.['is_call_accepted'],
      csvExport: !hide_col?.['is_call_accepted'],
      columnName: 'is_call_accepted',
    },
    {
      dataField: 'call_analytic_success_rate',
      text: 'Qualification Rate',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.PERCENT_SIGN),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CALLS.QUALIFICATION_RATE,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, loading_all_cmps_call_stats) => (loading_all_cmps_call_stats ? (<Skeleton />) : percentFormatWithTwoDecimalPlaces(cell || 0)),
      formatExtraData: loading_all_cmps_call_stats,
      csvFormatter: (cellContent, _row, _rowIndex) => SfPercentStringFormatter(cellContent || 0),
      hidden: hide_col?.['is_call_accept_rate'],
      csvExport: !hide_col?.['is_call_accept_rate'],
      columnName: 'is_call_accept_rate',
    },
    {
      dataField: 'call_analytic_avg_bid',
      text: 'Avg. Bid',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DOLLAR_SIGN),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CALLS.AVG_BID,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, loading_all_cmps_call_stats) => (loading_all_cmps_call_stats ? (<Skeleton />) : dollarFormatWithTwoDecimalPlaces(cell || 0)),
      formatExtraData: loading_all_cmps_call_stats,
      csvFormatter: (cellContent, _row, _rowIndex) => SfDollarStringFormatter(cellContent || 0),
      hidden: hide_col?.['is_call_avg_bid'],
      csvExport: !hide_col?.['is_call_avg_bid'],
      columnName: 'is_call_avg_bid',
    },
    {
      dataField: 'call_analytic_avg_cpc',
      text: 'CPC',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DOLLAR_SIGN),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CALLS.CPC,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, loading_all_cmps_call_stats) => (loading_all_cmps_call_stats ? (<Skeleton />) : dollarFormatWithTwoDecimalPlaces(cell || 0)),
      formatExtraData: loading_all_cmps_call_stats,
      csvFormatter: (cellContent, _row, _rowIndex) => SfDollarStringFormatter(cellContent || 0),
      hidden: hide_col?.['is_call_avg_cpc'],
      csvExport: !hide_col?.['is_call_avg_cpc'],
      columnName: 'is_call_avg_cpc',
    },
    {
      dataField: 'campaign_pace',
      text: 'Pace',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DOLLAR_SIGN),
      isDataFieldName: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.GENERIC.PACE,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, row, rowIndex, loading_stats) => {
        return loading_stats ? (<Skeleton />) : (dollarFormatWithTwoDecimalPlaces(cell || '0.00'))
      },
      formatExtraData: loading_stats,
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_campaign_pace']),
      hidden: (hide_col?.['is_campaign_pace'] === null) ? true : (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CAMPAIGN_PACE) || hide_col?.['is_campaign_pace']),
      columnName: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CAMPAIGN_PACE) ? 'is_campaign_pace' : '',
    },
    {
      dataField: 'total_cost',
      text: 'Spend',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DOLLAR_SIGN),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CALLS.SPEND,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      sortFunc: sortStringAsFloat,
      formatter: (cell, _row, _rowIndex, loading_all_cmps_call_stats) => (loading_all_cmps_call_stats ? (<Skeleton />) : dollarFormatWithTwoDecimalPlaces(cell || 0)),
      formatExtraData: loading_all_cmps_call_stats,
      csvFormatter: (cellContent, _row, _rowIndex) => SfDollarStringFormatter(cellContent || 0),
      hidden: hide_col?.['is_call_spend'],
      csvExport: !hide_col?.['is_call_spend'],
      columnName: 'is_call_spend',
    },
    {
      dataField: 'call_analytic_avg_call_duration',
      text: 'Avg. Duration',
      footer: '',
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CALLS.AVG_DURATION,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, loading_all_cmps_call_stats) => (loading_all_cmps_call_stats ? (<Skeleton />) : timeFormatter(cell || 0)),
      formatExtraData: loading_all_cmps_call_stats,
      csvFormatter: (cellContent, _row, _rowIndex) => timeFormatter(cellContent || 0),
      hidden: nullHandlerCustomizeColumns(hide_col?.['is_call_avg_duration']),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_call_avg_duration']),
      columnName: 'is_call_avg_duration',
    },
    {
      dataField: 'wait_time',
      text: 'Wait Time',
      footer: '',
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CALLS.WAIT_TIME,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, row, rowIndex, loading_all_cmps_call_stats) => (loading_all_cmps_call_stats ? (<Skeleton />) : (cell == null ? (cell = 0) : cell.toLocaleString())),
      formatExtraData: loading_all_cmps_call_stats,
      csvFormatter: (_cellContent, row, rowIndex) => (_cellContent == null ? (_cellContent = 0) : _cellContent.toLocaleString()),
      hidden: nullHandlerCustomizeColumns(hide_col?.['is_call_wait_time']),
      csvExport: !nullHandlerCustomizeColumns(!hide_col?.['is_call_wait_time']),
      csvExport: false,
    },
    {
      dataField: 'campaign_notes',
      text: 'Notes',
      footer: '',
      tooltipDescription: TOOLTIPS.CAMPAIGNS.GENERIC.NOTES,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: false,
      formatter: notesFormatter,
      formatExtraData: campaign_notes_loading,
      csvExport: false,
      hidden: (hide_col?.['is_campaign_notes'] === null) ? true : (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_NOTES_COLUMN_FOR_ADMIN_VIEW) || hide_col?.['is_campaign_notes']),
      columnName: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_NOTES_COLUMN_FOR_ADMIN_VIEW) ? 'is_campaign_notes' : '',
    },
    {
      dataField: 'win_rate',
      text: 'Win Rate',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.PERCENT_SIGN),
      isDataFieldName: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CLICKS.WIN_RATE,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      sortFunc: sortStringAsFloat,
      formatter: (cell, _row) => (loading_all_cmps_call_stats ? (<Skeleton />) : percentFormatWithTwoDecimalPlaces(cell * 100 || 0)),
      formatExtraData: loading_all_cmps_call_stats,
      csvExport: false,
      hidden: (hide_col?.['is_win_rate'] === null) ? true : bsh_isAdminUserDetailsPresent() ? isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_WIN_RATE) ? hide_col?.['is_win_rate'] : true : true,
      columnName: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_WIN_RATE) && bsh_isAdminUserDetailsPresent() ? 'is_win_rate' : '',
    }
  ]

  const leadsColumns = [
    {
      dataField: 'lead_analytic_total_inventory',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
      isDataFieldName: true,
      text: 'Inventory',
      tooltipDescription: TOOLTIPS.CAMPAIGNS.LEADS.INVENTORY,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, row, rowIndex, loading_all_cmps_lead_stats) => (loading_all_cmps_lead_stats ? (<Skeleton />) : Sfdelimitter(cell)),
      formatExtraData: leads_stats_loading,
      csvFormatter: (cellContent, _row, _rowIndex) => SfCommaStringFormatter(cellContent || 0),
      hidden: nullHandlerCustomizeColumns(hide_col?.['is_lead_inventory']),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_lead_inventory']),
      columnName: 'is_lead_inventory',
    },
    {
      dataField: 'lead_analytic_total_opportunities',
      text: 'Opportunities',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
      isDataFieldName: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.LEADS.QUERIES,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, loading_all_cmps_lead_stats) => (loading_all_cmps_lead_stats ? (<Skeleton />) : Sfdelimitter(cell)),
      formatExtraData: leads_stats_loading,
      csvFormatter: (cellContent, _row, _rowIndex) => SfCommaStringFormatter(cellContent || 0),
      hidden: nullHandlerCustomizeColumns(hide_col?.['is_lead_opportunities']),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_lead_opportunities']),
      columnName: 'is_lead_opportunities',
    },
    {
      dataField: 'lead_analytic_target_rate',
      text: 'Target Rate',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.PERCENT_SIGN),
      isDataFieldName: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.LEADS.TARGET_RATE,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, loading_all_cmps_lead_stats) => (loading_all_cmps_lead_stats ? (<Skeleton />) : percentFormatWithTwoDecimalPlaces(cell || 0)),
      formatExtraData: leads_stats_loading,
      csvFormatter: (cellContent, _row, _rowIndex) => SfPercentStringFormatter(cellContent || 0),
      hidden: nullHandlerCustomizeColumns(hide_col?.['is_lead_target_rate']),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_lead_target_rate']),
      columnName: 'is_lead_target_rate',
    },
    {
      dataField: 'lead_analytic_total_searches',
      text: 'Bids',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
      isDataFieldName: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.LEADS.SEARCHES,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, loading_all_cmps_lead_stats) => (loading_all_cmps_lead_stats ? (<Skeleton />) : Sfdelimitter(cell)),
      formatExtraData: leads_stats_loading,
      csvFormatter: (cellContent, _row, _rowIndex) => SfCommaStringFormatter(cellContent || 0),
      hidden: nullHandlerCustomizeColumns(hide_col?.['is_lead_bids']),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_lead_bids']),
      columnName: 'is_lead_bids',
    },
    {
      dataField: 'lead_analytic_bid_rate',
      text: 'Bid Rate',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.PERCENT_SIGN),
      isDataFieldName: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.LEADS.BID_RATE,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, loading_all_cmps_lead_stats) => (loading_all_cmps_lead_stats ? (<Skeleton />) : percentFormatWithTwoDecimalPlaces(cell || 0)),
      formatExtraData: leads_stats_loading,
      csvFormatter: (cellContent, _row, _rowIndex) => SfPercentStringFormatter(cellContent || 0),
      hidden: nullHandlerCustomizeColumns(hide_col?.['is_lead_bid_rate']),
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_lead_bid_rate']),
      columnName: 'is_lead_bid_rate',
    },
    {
      dataField: 'lead_analytic_total_won',
      text: 'Posts',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.LEADS.POSTS,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, loading_all_cmps_lead_stats) => (loading_all_cmps_lead_stats ? (<Skeleton />) : Sfdelimitter(cell)),
      formatExtraData: leads_stats_loading,
      csvFormatter: (cellContent, _row, _rowIndex) => SfCommaStringFormatter(cellContent || 0),
      hidden: hide_col?.['is_lead_posts'],
      csvExport: !hide_col?.['is_lead_posts'],
      columnName: 'is_lead_posts',
    },
    {
      dataField: 'lead_analytic_total_leads',
      text: 'Accepted Leads',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.LEADS.ACCEPTED_LEADS,
      headerFormatter: forColumnHeaderWrapper,
      splitHeader: true,
      sort: true,
      formatter: (cell, _row, _rowIndex, loading_all_cmps_lead_stats) => (loading_all_cmps_lead_stats ? (<Skeleton />) : Sfdelimitter(cell)),
      formatExtraData: leads_stats_loading,
      csvFormatter: (cellContent, _row, _rowIndex) => SfCommaStringFormatter(cellContent || 0),
      hidden: hide_col?.['is_lead_accepted'],
      csvExport: !hide_col?.['is_lead_accepted'],
      columnName: 'is_lead_accepted',
    },
    {
      dataField: 'lead_analytic_success_rate',
      text: 'Accept Rate',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.PERCENT_SIGN),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.LEADS.ACCEPT_RATE,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, loading_all_cmps_lead_stats) => (loading_all_cmps_lead_stats ? (<Skeleton />) : percentFormatWithTwoDecimalPlaces(cell || 0)),
      csvFormatter: (cellContent, _row, _rowIndex) => SfPercentStringFormatter(cellContent || 0),
      formatExtraData: leads_stats_loading,
      hidden: hide_col?.['is_lead_accept_rate'],
      csvExport: !hide_col?.['is_lead_accept_rate'],
      columnName: 'is_lead_accept_rate',
    },
    {
      dataField: 'lead_analytic_avg_bid',
      text: 'Avg Bid',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DOLLAR_SIGN),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.LEADS.AVG_BID,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _row, _rowIndex, loading_all_cmps_lead_stats) => (loading_all_cmps_lead_stats ? (<Skeleton />) : dollarFormatWithTwoDecimalPlaces(cell || 0)),
      formatExtraData: leads_stats_loading,
      csvFormatter: (cellContent, _row, _rowIndex) => SfDollarStringFormatter(cellContent || 0),
      hidden: hide_col?.['is_lead_avg_bid'],
      csvExport: !hide_col?.['is_lead_avg_bid'],
      columnName: 'is_lead_avg_bid',
    },
    {
      dataField: 'lead_analytic_avg_cpl',
      text: 'CPL',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DOLLAR_SIGN),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.LEADS.CPL,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, row, rowIndex, loading_all_cmps_lead_stats) => (loading_all_cmps_lead_stats ? (<Skeleton />) : dollarFormatWithTwoDecimalPlaces(cell || 0)),
      formatExtraData: leads_stats_loading,
      csvFormatter: (cellContent, _row, _rowIndex) => SfDollarStringFormatter(cellContent || 0),
      hidden: hide_col?.['is_lead_avg_cpl'],
      csvExport: !hide_col?.['is_lead_avg_cpl'],
      columnName: 'is_lead_avg_cpl',
    },
    {
      dataField: 'campaign_pace',
      text: 'Pace',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DOLLAR_SIGN),
      isDataFieldName: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.GENERIC.PACE,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, row, rowIndex, loading_stats) => {
        return loading_stats ? (<Skeleton />) : (dollarFormatWithTwoDecimalPlaces(cell || '0.00'))
      },
      formatExtraData: loading_stats,
      csvExport: !nullHandlerCustomizeColumns(hide_col?.['is_campaign_pace']),
      hidden: (hide_col?.['is_campaign_pace'] === null) ? true : (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CAMPAIGN_PACE) || hide_col?.['is_campaign_pace']),
      columnName: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CAMPAIGN_PACE) ? 'is_campaign_pace' : '',
    },
    {
      dataField: 'total_cost',
      text: 'Spend',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DOLLAR_SIGN),
      isDataFieldName: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.LEADS.SPEND,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      sortFunc: sortStringAsFloat,
      formatter: (cell, _row, _rowIndex, loading_all_cmps_lead_stats) => (loading_all_cmps_lead_stats ? (<Skeleton />) : dollarFormatWithTwoDecimalPlaces(cell || 0)),
      formatExtraData: leads_stats_loading,
      csvFormatter: (cellContent, _row, _rowIndex) => SfDollarStringFormatter(cellContent || 0),
      hidden: hide_col?.['is_lead_spend'],
      csvExport: !hide_col?.['is_lead_spend'],
      columnName: 'is_lead_spend',
    },
    {
      dataField: 'campaign_notes',
      text: 'Notes',
      footer: '',
      tooltipDescription: TOOLTIPS.CAMPAIGNS.GENERIC.NOTES,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: false,
      formatter: notesFormatter,
      formatExtraData: campaign_notes_loading,
      csvExport: false,
      hidden: (hide_col?.['is_campaign_notes'] === null) ? true : (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_NOTES_COLUMN_FOR_ADMIN_VIEW) || hide_col?.['is_campaign_notes']),
      columnName: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_NOTES_COLUMN_FOR_ADMIN_VIEW) ? 'is_campaign_notes' : '',
    },
    {
      dataField: 'win_rate',
      text: 'Win Rate',
      footer: '',
      footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.PERCENT_SIGN),
      isDataFieldName: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.CLICKS.WIN_RATE,
      hasBothTooltips: true,
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      sortFunc: sortStringAsFloat,
      formatter: (cell, _row) => (leads_stats_loading ? (<Skeleton />) : percentFormatWithTwoDecimalPlaces(cell * 100 || 0)),
      formatExtraData: leads_stats_loading,
      csvExport: false,
      hidden: (hide_col?.['is_win_rate'] === null) ? true : bsh_isAdminUserDetailsPresent() ? isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_WIN_RATE) ? hide_col?.['is_win_rate'] : true : true,
      columnName: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_WIN_RATE) && bsh_isAdminUserDetailsPresent() ? 'is_win_rate' : '',
    }
  ]
  const columnsNeverExport = ['options', 'campaign_notes'];

  const finalColumns = useMemo(() => {
    const baseColumns = [statusColumn, nameColumn, ...(show_rtb_brand_ui_changes ? [brandColumn] : [])];

    const totalPixelConversionandRevenueColumns = isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_CONVERSION_AND_REVENUE_METRICS) ? totalConversionandRevenueColumns : [];
    
    let oldColumns = [...baseColumns, ...columns, ...dynamicColumns, ...profitAndCRColumns, ...totalPixelConversionandRevenueColumns];
    let newColumns = [...baseColumns, ...commonColumnsForAllTypes];

    if (new_campaign_page_feature_flag_active) {
      if (selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CLICKS || selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS) {
        return [...newColumns, ...clicksColumns, ...dynamicColumns, ...profitAndCRColumns, ...totalPixelConversionandRevenueColumns]
      } else if (selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.CALLS) {
        if (show_pixel_stats_for_leads_and_calls) {
          return [...newColumns, ...callsColumns, ...dynamicColumns, ...profitAndCRColumns, ...totalPixelConversionandRevenueColumns]
        }
        return [...newColumns, ...callsColumns]
      } else if (selectedProductGroup?.value === NAME_OF_PRODUCT_TYPES.LEADS) {
        if (show_pixel_stats_for_leads_and_calls) {
          return [...newColumns, ...leadsColumns, ...dynamicColumns, ...profitAndCRColumns, ...totalPixelConversionandRevenueColumns]
        }
        return [...newColumns, ...leadsColumns]
      } else {
        return [...newColumns, ...genericColumns, ...dynamicColumns, ...profitAndCRColumns, ...totalPixelConversionandRevenueColumns]
      }
    } else {
      return oldColumns
    }
  }, [columns, clicksColumns, dynamicColumns, commonColumnsForAllTypes, profitAndCRColumns, totalConversionandRevenueColumns, statusColumn, nameColumn, optionColumn, new_campaign_page_feature_flag_active, selectedProductGroup, brandColumn, show_rtb_brand_ui_changes]);

  const mapped_final_columns = useMemo(() => {
    return finalColumns.map((column) => {
      return {
        ...column,
        footerData: footerStats
      }

    })
  }, [finalColumns, footerStats]);

  const sortedColumns = useMemo(() => {

    const columnOrders = calculateColumnOrders(mapped_final_columns, campaigns_customize_order, selectedProductGroup?.label)

    if (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_CAMPAIGNS_PAGE)) {
      return mapped_final_columns
    }
    else {
      return sortColumnsByOrder(mapped_final_columns, columnOrders);
    }
  }, [callsColumns, leadsColumns, customizeColumnsOrder, customizeColumnsModal, clicksColumns, genericColumns])

  // Remove footer properties when there's no data to prevent empty footer row
  const columnsWithConditionalFooter = useMemo(() => {
    const hasActualData = (combinedCampaignsStats || []).length > 0;
    return sortedColumns.map((column) => ({
      ...column,
      ...(hasActualData ? {} : { footer: undefined, footerFormatter: undefined })
    }))
  }, [sortedColumns, combinedCampaignsStats])

  // Ensure csvExport respects the hidden property to match UI visibility
  const columnsHandlingHidden = useMemo(() => {
    return handleColumnsForCsvExport(columnsWithConditionalFooter, columnsNeverExport)
  }, [columnsWithConditionalFooter])

  return (
    <>
      {/* Models  */}
      <DeleteCampaignModal
        deleteModalState={deleteCampaignModal}
        onDeleteClick={onSaveDeleteCampaign}
        textMessage="Are you sure you want to delete this campaign?"
        onCloseClick={() => setDeleteCampaignModal({ action: false })}
      />
      <DeleteCampaignModal
        deleteModalState={bulkDeleteCampaignModal}
        onDeleteClick={onSaveBulkDeleteCampaign}
        textMessage="Are you sure you want to delete these campaigns?"
        onCloseClick={() => setBulkDeleteCampaignModal({ action: false })}
      />

      <CustomizeColumnsModal
        isNewCustomizeColumnApproach={true}
        pageName={PAGES_FOR_DRAGGABLE_CUSTOMIZE_COLUMN.CAMPAIGNS}
        modalState={customizeColumnsModal}
        onSubmitModalState={onSubmitCustomizeColumnsModal}
        setModalState={setCustomizeColumnsModal}
        handleColumns={handleColumns}
        onClickModalClose={onClickCloseCustomizeColumns}
        dragndropFeatureFlag={REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_CAMPAIGNS_PAGE}
      />

      <CampaignNoteModal
        modalState={campaignNoteModal}
        onSubmitClick={onSubmitCampaignNoteModal}
        onCloseClick={() => setCampaignNoteModal({ action: false })}
        textHeading={"Notes"}
      />
      {/* Models */}
      <div onClick={closeDropdown} className="page-content" id="page-content-wrapper">
        <MetaTags>
          <title>All Campaigns | {AppConfiguration.WEBSITE}</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between">
            <Breadcrumbs breadcrumbItem="Campaigns" copyUrl={true} />
            <div className="float-end">
              {(isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_USER_COLUMN_PREFERENCE) || (dynamicColumns.length > 0)) ? (
                <button className="d-flex align-items-center text-sfblue bg-transparent rounded border-0" type="button" onClick={onClickOpenCustomizeColumnsModal}>
                  <i className="bx bx-columns font-size-18 me-2 bx-sm" />
                  Customize Columns
                </button>
              ) : null}
            </div>
          </div>
          {/* Data table starts */}
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <ToolkitProvider
                    keyField="id"
                    columns={[{ dataField: "dummy", hidden: true, csvExport: false }, ...columnsHandlingHidden, optionColumn]}
                    data={combinedCampaignsStats}
                    exportCSV={{
                      fileName: "Campaigns.csv",
                      exportAll: false,
                    }}

                  >
                    {(toolkitProps) => (
                      <>
                        {selectedRows && selectedRows.length > 0
                          ? (
                            <Row className="d-flex align-items-end">
                              <Col xl="2" className="align-items-end">
                                <FormGroup className="mt-3 mb-0">
                                  <div>
                                    <Select
                                      placeholder={`Bulk Edit (${selectedRows.length})`}
                                      value={bulkEdit}
                                      onChange={onBulkEdit}
                                      options={optionBulkEdit}
                                      classNamePrefix="select2-selection"
                                    />
                                  </div>
                                </FormGroup>
                              </Col>
                            </Row>
                          )
                          : (
                            <Form>
                              <Row className="">
                                <Col className="align-self-end">
                                  <FormGroup className="mb-0">
                                    <Label className="font-weight-semibold">Status</Label>
                                    <div>
                                      <Select
                                        value={selectedStatusGroup}
                                        onChange={(value) => {
                                          setSelectedStatusGroup(value)
                                          updateUrlFilters(CAMPAIGN_FILTERS.STATUS, value?.value);
                                          bsh_setFilters(STORAGE_KEY.FILTERS.CAMPAIGN, CAMPAIGN_FILTERS.STATUS, value);
                                        }}
                                        options={optionGroupStatus}
                                        classNamePrefix="select2-selection"
                                      />
                                    </div>
                                  </FormGroup>
                                </Col>
                                {show_rtb_brand_ui_changes &&
                                  <Col className="align-self-end">
                                    <FormGroup className="mb-0 rtb-brands-dropdown">
                                      <Label className="font-weight-semibold">Brands</Label>
                                      <ReactMultiselectCheckboxes
                                        className="sf-checkbox"
                                        hideSearch
                                        getDropdownButtonLabel={getDropdownButtonLabelForBrands}
                                        value={selectedBrands}
                                        onChange={(selectedOption, event) => {
                                          handleSelectedBrands(selectedOption, event);
                                        }}
                                        options={brandsOptions}
                                      />
                                    </FormGroup>
                                  </Col>
                                }
                                <Col className="align-self-end">
                                  <FormGroup className="mb-0">
                                    <Label className="font-weight-semibold">Product</Label>
                                    <div>
                                      <Select
                                        value={selectedProductGroup}
                                        onChange={(value) => {
                                          setSelectedProductGroup(value)
                                          updateUrlFilters(CAMPAIGN_FILTERS.PRODUCT, value?.value);
                                          bsh_setFilters(STORAGE_KEY.FILTERS.CAMPAIGN, CAMPAIGN_FILTERS.PRODUCT, value);
                                        }}
                                        options={optionsCampaignProducts}
                                        classNamePrefix="select2-selection"
                                      />
                                    </div>
                                  </FormGroup>
                                </Col>
                                <Col className="align-self-end">
                                  <FormGroup className="mb-0">
                                    <Label className="font-weight-semibold">Type</Label>
                                    <div>
                                      <Select
                                        value={selectedLeadGroup}
                                        onChange={(value) => {
                                          setSelectedLeadGroup(value)
                                          updateUrlFilters(CAMPAIGN_FILTERS.LEAD_TYPE, value?.value);
                                          bsh_setFilters(STORAGE_KEY.FILTERS.CAMPAIGN, CAMPAIGN_FILTERS.LEAD_TYPE, value);
                                        }}
                                        options={optionLeadTypesState}
                                        classNamePrefix="select2-selection"
                                      />
                                    </div>
                                  </FormGroup>
                                </Col>
                                <Col className="align-self-end">
                                  <FormGroup className="mb-0">
                                    <DateRangePicker
                                      ianaTz={getIANATimezoneStringForAbbreviation(current_account?.timezone)}
                                      value={selectedDateRange}
                                      options={Object.keys(DATE_RANGE_OPTIONS).map((opt) => createOption(
                                        DATE_RANGE_OPTIONS[opt],
                                        new Date(),
                                        getIANATimezoneStringForAbbreviation(current_account?.timezone),
                                      ))}
                                      onChange={(value) => {
                                        setSelectedDateRange(value);
                                        updateUrlFilters(CAMPAIGN_FILTERS.DATE_RANGE, value?.original_label === DATE_RANGE_OPTIONS.CUSTOM_RANGE ? { startDate: value?.value?.startDate, endDate: value?.value?.endDate } : value?.original_label);
                                        bsh_setFilters(STORAGE_KEY.FILTERS.CAMPAIGN, CAMPAIGN_FILTERS.DATE_RANGE, value);
                                      }}
                                    />
                                  </FormGroup>
                                </Col>
                                <Col className="align-self-end">
                                  <FormGroup className="mb-0">
                                    <div className="search-box me-2 d-inline-block">
                                      <div className="position-relative">
                                        {/* TODO: Use SearchBar Instead like in Adgroups.js */}
                                        <Input
                                          className="rounded"
                                          value={selectedName}
                                          placeholder="Search"
                                          onChange={(e) => {
                                            nameFilter(e.target.value);
                                            setSelectedName(e.target.value);
                                          }}
                                        />
                                        <i className="bx bx-search-alt search-icon" />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </Col>
                                <Col xl="auto" className="align-self-end">
                                  <FormGroup className="mb-0">
                                    <div>
                                      {current_role_permissions_state && current_role_permissions_state.find(single_obj => single_obj.ui_key === UI_PERMISSION_KEY.EXPORT_DATA).isActive && (
                                        <ExportCSVButton className="btn btn-outline-sfblue" {...toolkitProps.csvProps}>
                                          <i className="bx bx-import font-size-14 align-middle me-2" />
                                          Export
                                        </ExportCSVButton>
                                      )}
                                    </div>
                                  </FormGroup>
                                </Col>
                                <Col xl="auto" className="align-self-end">
                                  {(canCreateNewCampaign) && (
                                    <FormGroup className="mt-3 mb-0">
                                      <div id='new_campaign_button'>
                                        <Link
                                          className={`btn ${getPrimaryButtonClass()}`}
                                          to="/campaigns/create"
                                        >
                                          <i className="bx bx-plus font-size-14 align-middle me-2" />
                                          New Campaign
                                        </Link>
                                      </div>
                                    </FormGroup>
                                  )}
                                </Col>
                              </Row>
                            </Form>
                          )}
                        <Row id='campaigns-table' className={`${enable_sticky_columns ? '' : 'sfTable-Container-for-creatives-campaigns'}`}>
                          <Col xl="12">
                            {loading || user_column_preference_campaign_loading ? (
                              <SfLoadingSkeleton rows={8} cols={6} />
                            ) : (enable_sticky_columns ? (
                              <StickyBootstrapTableWrapper
                                keyField="id"
                                responsive
                                bordered={false}
                                striped={false}
                                defaultSorted={defaultSorted}
                                selectRow={selectRow}
                                rowClasses="tr-hover"
                                rowEvents={rowEvents}
                                filter={filterFactory()}
                                headerClasses="sftableHeader text-black"
                                classes={`table align-middle table-nowrap text-black ${(combinedCampaignsStats || []).length > 0 ? 'customize-footer-table' : 'customize-footer-table-hidden'}`}
                                headerWrapperClasses="thead-light"
                                noDataIndication="You currently don't have any campaigns"
                                table_1_classes={show_rtb_brand_ui_changes ? 'sfTable-Container-for-campaigns-tab-1' : 'sfTable-Container-for-creatives-campaigns-tab-1'}
                                setSortOrderForName={setSortOrderForName}
                                sort={{ sortCaret: customSortCaret }}
                                {...toolkitProps.baseProps}
                              />
                            ) : (
                              <BootstrapTable
                                keyField="id"
                                responsive
                                bordered={false}
                                striped={false}
                                defaultSorted={defaultSorted}
                                selectRow={selectRow}
                                rowClasses="tr-hover"
                                rowEvents={rowEvents}
                                filter={filterFactory()}
                                headerClasses="sftableHeader text-black thead-h70"
                                classes={`table align-middle table-nowrap text-black ${(combinedCampaignsStats || []).length > 0 ? 'customize-footer-table' : 'customize-footer-table-hidden'}`}
                                headerWrapperClasses="thead-light"
                                noDataIndication="You currently don't have any campaigns"
                                sort={{ sortCaret: customSortCaret }}
                                {...toolkitProps.baseProps}
                              />
                            )
                            )}
                          </Col>
                        </Row>
                      </>
                    )}
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/* Data table ends */}
        </Container>
      </div>
    </>
  );
}

export default QfCampaignsPage;
